var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitInformationImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 631.397 561.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-66{opacity:.4}.cls-5{fill:#e2e2e2}.cls-108,.cls-110,.cls-113,.cls-115,.cls-49,.cls-50,.cls-51,.cls-55{stroke-linecap:round}.cls-108,.cls-110,.cls-113,.cls-115,.cls-31,.cls-38,.cls-49,.cls-50,.cls-51,.cls-55{stroke-miterlimit:10;fill:none}.cls-8{opacity:.33}.cls-10{fill:#848484}.cls-14{fill:#b9b9b9}.cls-15{opacity:.5}.cls-16{fill:#d7d7d7}.cls-17{fill:#d1d1d1}.cls-18{fill:#cfcfcf}.cls-19{fill:#c3c3c3}.cls-20{fill:#d6d6d6}.cls-21{fill:#aeaeae}.cls-22{fill:#9a9a9a}.cls-25{fill:#a7a7a7}.cls-26{fill:#9c9c9c}.cls-27{fill:#c7c7c7}.cls-28{fill:#d2d2d2}.cls-29{fill:#c1c1c1}.cls-31{stroke:#e6e6e6}.cls-32{fill:#dbdbdb}.cls-33{fill:#cacaca}.cls-34{fill:#b3b3b3}.cls-38{stroke:#e7e7e7}.cls-39{fill:#cecece}.cls-41{fill:#cdcdcd}.cls-43{fill:silver}.cls-44{fill:#cbcbcb}.cls-46{fill:#b8b8b8}.cls-47{fill:#c4c4c4}.cls-48{fill:#00203a}.cls-49{stroke:#00203a}.cls-49,.cls-55{stroke-width:1.095px}.cls-108,.cls-113,.cls-50,.cls-51{stroke:#fff}.cls-50,.cls-51{stroke-width:.274px}.cls-51{stroke-dasharray:1.093 1.093}.cls-52{fill:#f7f8fb}.cls-53{fill:#d5ddea}.cls-54{fill:#52151d}.cls-110,.cls-115,.cls-55{stroke:#f7f8fb}.cls-56{fill:#6f6b7f}.cls-57{fill:#a7a0bf}.cls-58{fill:#ead6c1}.cls-59{fill:#d7f2e0}.cls-60{fill:#88d8a3}.cls-62{fill:#4e3f2e}.cls-65{fill:#7d5932}.cls-66{fill:#5e4326}.cls-67{fill:#008470}.cls-68{fill:#66cfbf}.cls-73{fill:#3a3228}.cls-74{fill:#2f3b43}.cls-75{fill:#3f4f59}.cls-76{fill:#25353f}.cls-77{fill:#2b3e4a}.cls-78{fill:#2e434f}.cls-79{fill:#385261}.cls-80{fill:#334957}.cls-81{fill:#34424a}.cls-82{fill:#4e626e}.cls-83{fill:#536875}.cls-84{fill:#324a57}.cls-85{fill:#3a5463}.cls-86{fill:#bf874b}.cls-87{fill:#ccc56c}.cls-88{fill:#d6af84}.cls-89{fill:#e9c6a1}.cls-90{fill:#631700}.cls-95{fill:#d1d5d7}.cls-96{fill:#868b8e}.cls-97{fill:#abbcd5}.cls-98{fill:#e4ebf4}.cls-101{fill:#bdc9dd}.cls-103{fill:#264a80}.cls-104{fill:#e0b689}.cls-110{stroke-width:1.025px}.cls-108{stroke-width:.256px}.cls-113{stroke-width:.25px}.cls-116{fill:#1f2d36}.cls-118{fill:#38474f}.cls-119{fill:#19252b}.cls-120{fill:#0e161a}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(0 11.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(48.537 464.236)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 264.119,
    cy: 42.591,
    rx: 264.119,
    ry: 42.591,
    opacity: 0.4,
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0 -11.978)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(301.745 38.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M87.381 3.872a3.872 3.872 0 1 0-3.872 3.872 3.779 3.779 0 0 0 3.872-3.872z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "#e2e2e2",
    strokeWidth: 3.573,
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M29.718 50.196l53.515-45.08 56.972 45.08",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    stroke: "#e2e2e2",
    strokeWidth: 3.573
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-5",
    transform: "translate(75.489 264.119)",
    d: "M0 0h18.945v122.103H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 371.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-5",
    d: "M224.419 338.292a6.347 6.347 0 0 1-5.531-3.319 6.151 6.151 0 0 1 2.627-8.3l82-42.176 81.172 42.176a6.154 6.154 0 0 1-5.67 10.924l-75.5-39.272-76.194 39.275a5.615 5.615 0 0 1-2.904.692z",
    transform: "translate(-218.209 -284.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M368.3 266.567H235.137A13.22 13.22 0 0 1 222 253.43V64.537A13.22 13.22 0 0 1 235.137 51.4H368.3a13.22 13.22 0 0 1 13.137 13.137v188.755a13.161 13.161 0 0 1-13.137 13.275z",
    transform: "translate(-216.758 -2.448)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M359.268 252.58H239.654a11.744 11.744 0 0 1-11.754-11.754V71.154A11.744 11.744 0 0 1 239.654 59.4h119.614a11.744 11.744 0 0 1 11.754 11.754v169.672a11.744 11.744 0 0 1-11.754 11.754z",
    transform: "translate(-214.5 .615)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    className: "cls-8",
    transform: "translate(24.739 74.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M284.385 96.977A26.821 26.821 0 0 0 277.609 79l-9.818 8.574a14.18 14.18 0 0 1 3.6 9.4 13.864 13.864 0 0 1-4.287 10.095l9.127 9.265a26.49 26.49 0 0 0 8.154-19.357z",
    transform: "translate(-224.232 -66.278)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-10",
    d: "M249.509 99.5L239 107.106a27.236 27.236 0 0 0 10.648 8.712l5.531-11.892a12.942 12.942 0 0 1-5.67-4.426z",
    transform: "translate(-234.99 -58.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-10",
    d: "M269.24 86.526l9.818-8.574a29.509 29.509 0 0 0-9.4-7.052L264.4 82.792a18.145 18.145 0 0 1 4.84 3.734z",
    transform: "translate(-225.266 -69.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M260.977 104.548a13.931 13.931 0 0 1-5.946-1.383l-5.531 11.893a26.762 26.762 0 0 0 11.477 2.489 27.541 27.541 0 0 0 19.221-7.882l-9.127-9.265a14.563 14.563 0 0 1-10.094 4.148z",
    transform: "translate(-230.97 -58.086)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M260.786 82.8a13.691 13.691 0 0 1 5.808 1.245l5.255-11.892a27.3 27.3 0 0 0-21.849-.14l5.116 12.031a14 14 0 0 1 5.67-1.244z",
    transform: "translate(-230.779 -69.8)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M249.237 97.367a14.274 14.274 0 0 1 8.712-13.137l-5.117-12.03a27.233 27.233 0 0 0-11.477 41.208l10.509-7.606a14.544 14.544 0 0 1-2.627-8.435z",
    transform: "translate(-236.1 -68.881)",
    fill: "#dadada"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    className: "cls-8",
    transform: "translate(41.333 126.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-14",
    d: "M252.248 164.767h-2.489a1.681 1.681 0 0 1-1.659-1.659v-21.849a1.681 1.681 0 0 1 1.659-1.659h2.489a1.681 1.681 0 0 1 1.659 1.659v21.849a1.78 1.78 0 0 1-1.659 1.659z",
    transform: "translate(-248.1 -94.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-14",
    d: "M316.348 162.777h-2.489a1.681 1.681 0 0 1-1.659-1.659v-14.659a1.681 1.681 0 0 1 1.659-1.659h2.489a1.681 1.681 0 0 1 1.659 1.659v14.8a1.569 1.569 0 0 1-1.659 1.518z",
    transform: "translate(-223.561 -92.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-14",
    d: "M258.948 167.753h-2.489a1.681 1.681 0 0 1-1.659-1.659v-32.635a1.681 1.681 0 0 1 1.659-1.659h2.489a1.681 1.681 0 0 1 1.659 1.659v32.773a1.768 1.768 0 0 1-1.659 1.521z",
    transform: "translate(-245.535 -97.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-14",
    d: "M309.948 167.753h-2.489a1.681 1.681 0 0 1-1.659-1.659v-32.635a1.681 1.681 0 0 1 1.659-1.659h2.489a1.681 1.681 0 0 1 1.659 1.659v32.773a1.569 1.569 0 0 1-1.659 1.521z",
    transform: "translate(-226.011 -97.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-14",
    d: "M267.5 169.208h-4.84a1.681 1.681 0 0 1-1.66-1.659v-37.89a1.681 1.681 0 0 1 1.659-1.659h4.84a1.682 1.682 0 0 1 1.659 1.659v37.889a1.682 1.682 0 0 1-1.658 1.66z",
    transform: "translate(-243.162 -99.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-14",
    d: "M294.2 169.208h-4.84a1.681 1.681 0 0 1-1.659-1.659v-37.89a1.681 1.681 0 0 1 1.658-1.659h4.84a1.682 1.682 0 0 1 1.659 1.659v37.889a1.78 1.78 0 0 1-1.658 1.66z",
    transform: "translate(-232.94 -99.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-14",
    d: "M284.8 169.208h-4.84a1.681 1.681 0 0 1-1.659-1.659v-37.89a1.681 1.681 0 0 1 1.658-1.659h4.84a1.682 1.682 0 0 1 1.659 1.659v37.889a1.6 1.6 0 0 1-1.658 1.66z",
    transform: "translate(-236.539 -99.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-14",
    d: "M276.944 170.51h-6.084a1.681 1.681 0 0 1-1.659-1.659v-42.592a1.681 1.681 0 0 1 1.659-1.659h6.084a1.681 1.681 0 0 1 1.659 1.659v42.591a1.78 1.78 0 0 1-1.659 1.66z",
    transform: "translate(-240.022 -100.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-14",
    d: "M304.344 177.133h-6.084a1.681 1.681 0 0 1-1.659-1.659v-66.515a1.681 1.681 0 0 1 1.659-1.659h6.084a1.681 1.681 0 0 1 1.656 1.659v66.514a1.78 1.78 0 0 1-1.656 1.66z",
    transform: "translate(-229.533 -107.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    className: "cls-15",
    transform: "translate(0 217.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-16",
    d: "M113.115 392.272H8.574A8.617 8.617 0 0 1 0 383.7V153.874a8.617 8.617 0 0 1 8.574-8.574h104.4a8.617 8.617 0 0 1 8.573 8.574V383.7a8.328 8.328 0 0 1-8.432 8.572z",
    transform: "translate(0 -145.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-17",
    d: "M114.8 145.4a7.232 7.232 0 0 1 .415 2.489v229.825a8.617 8.617 0 0 1-8.574 8.574H2.1c-.691 0-1.245-.138-1.8-.138a8.628 8.628 0 0 0 8.3 6.223H113a8.617 8.617 0 0 0 8.573-8.574V153.835a8.727 8.727 0 0 0-6.773-8.435z",
    transform: "translate(.115 -145.262)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(10.233 16.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-18",
    d: "M100.326 197.34H15.7a8.321 8.321 0 0 1-8.3-8.3V165.4a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.352 8.352 0 0 1-8.441 8.294z",
    transform: "translate(-7.4 -157.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-18",
    d: "M100.326 238.74H15.7a8.321 8.321 0 0 1-8.3-8.3V206.8a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.352 8.352 0 0 1-8.441 8.294z",
    transform: "translate(-7.4 -141.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-18",
    d: "M100.326 280.14H15.7a8.321 8.321 0 0 1-8.3-8.3V248.2a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.352 8.352 0 0 1-8.441 8.294z",
    transform: "translate(-7.4 -125.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-18",
    d: "M100.326 321.54H15.7a8.321 8.321 0 0 1-8.3-8.3V289.6a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.352 8.352 0 0 1-8.441 8.294z",
    transform: "translate(-7.4 -109.553)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-19",
    d: "M100.887 157.1a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H8.1a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V165.4a8.075 8.075 0 0 0-7.471-8.3z",
    transform: "translate(-7.132 -157.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-19",
    d: "M100.887 198.5a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H8.1a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V206.8a8.167 8.167 0 0 0-7.471-8.3z",
    transform: "translate(-7.132 -141.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-19",
    d: "M100.887 239.9a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H8.1a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V248.2a8.167 8.167 0 0 0-7.471-8.3z",
    transform: "translate(-7.132 -125.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-19",
    d: "M100.887 281.3a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H8.1a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V289.6a8.167 8.167 0 0 0-7.471-8.3z",
    transform: "translate(-7.132 -109.553)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-20",
    d: "M88.094 187.05H19.229a7.35 7.35 0 0 1-7.329-7.19v-12.169a7.26 7.26 0 0 1 7.329-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.23 7.23 0 0 1-7.191 7.19z",
    transform: "translate(4.556 -139.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-20",
    d: "M88.094 228.35H19.229a7.35 7.35 0 0 1-7.329-7.19v-12.169a7.26 7.26 0 0 1 7.329-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.141 7.141 0 0 1-7.191 7.19z",
    transform: "translate(4.556 -123.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-20",
    d: "M88.094 269.612H19.229a7.35 7.35 0 0 1-7.329-7.191v-12.03a7.26 7.26 0 0 1 7.329-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.031a7.141 7.141 0 0 1-7.191 7.19z",
    transform: "translate(4.556 -107.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-20",
    d: "M88.094 311.05H19.229a7.35 7.35 0 0 1-7.329-7.191v-12.168a7.26 7.26 0 0 1 7.329-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.23 7.23 0 0 1-7.191 7.19z",
    transform: "translate(4.556 -92.011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(54.483 30.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-21",
    cx: 6.361,
    cy: 6.361,
    r: 6.361
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-21",
    d: "M52.122 214.761a6.361 6.361 0 1 0-6.361 6.361 6.259 6.259 0 0 0 6.361-6.361z",
    transform: "translate(-39.4 -151.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-21",
    d: "M52.122 256.161a6.361 6.361 0 1 0-6.361 6.361 6.258 6.258 0 0 0 6.361-6.361z",
    transform: "translate(-39.4 -135.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-21",
    d: "M52.122 297.561a6.361 6.361 0 1 0-6.361 6.361 6.258 6.258 0 0 0 6.361-6.361z",
    transform: "translate(-39.4 -119.453)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-22",
    d: "M48.044 167.4a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.086 8.086 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-39.055 -166.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-22",
    d: "M48.044 208.8a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.085 8.085 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-39.055 -150.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-22",
    d: "M48.044 250.2a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.087 8.087 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-39.055 -135.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-22",
    d: "M48.044 291.6a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.088 8.088 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.424 6.424 0 0 0-3.734-5.808z",
    transform: "translate(-39.055 -119.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    className: "cls-15",
    transform: "translate(509.57 217.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-16",
    d: "M481.477 392.272h-104.4a8.617 8.617 0 0 1-8.577-8.572V153.874a8.617 8.617 0 0 1 8.573-8.574h104.4a8.617 8.617 0 0 1 8.574 8.574V383.7a8.36 8.36 0 0 1-8.57 8.572z",
    transform: "translate(-368.5 -145.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-17",
    d: "M483.259 145.4a7.233 7.233 0 0 1 .415 2.489v229.825a8.617 8.617 0 0 1-8.573 8.574H370.7c-.691 0-1.245-.138-1.8-.138a8.628 8.628 0 0 0 8.3 6.223h104.4a8.617 8.617 0 0 0 8.573-8.574V153.835a9.005 9.005 0 0 0-6.914-8.435z",
    transform: "translate(-368.347 -145.262)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(10.095 16.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-18",
    d: "M468.864 197.34H384.1a8.321 8.321 0 0 1-8.3-8.3V165.4a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.148 8.148 0 0 1-8.303 8.294z",
    transform: "translate(-375.8 -157.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-18",
    d: "M468.864 238.74H384.1a8.321 8.321 0 0 1-8.3-8.3V206.8a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.148 8.148 0 0 1-8.303 8.294z",
    transform: "translate(-375.8 -141.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-18",
    d: "M468.864 280.14H384.1a8.321 8.321 0 0 1-8.3-8.3V248.2a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.148 8.148 0 0 1-8.303 8.294z",
    transform: "translate(-375.8 -125.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-18",
    d: "M468.864 321.54H384.1a8.321 8.321 0 0 1-8.3-8.3V289.6a8.321 8.321 0 0 1 8.3-8.3h84.767a8.321 8.321 0 0 1 8.3 8.3v23.646a8.148 8.148 0 0 1-8.303 8.294z",
    transform: "translate(-375.8 -109.553)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-19",
    d: "M469.387 157.1a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H376.6a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V165.4a8.075 8.075 0 0 0-7.471-8.3z",
    transform: "translate(-375.494 -157.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-19",
    d: "M469.387 198.5a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H376.6a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V206.8a8.166 8.166 0 0 0-7.471-8.3z",
    transform: "translate(-375.494 -141.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-19",
    d: "M469.387 239.9a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H376.6a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V248.2a8.166 8.166 0 0 0-7.471-8.3z",
    transform: "translate(-375.494 -125.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-19",
    d: "M469.387 281.3a8.448 8.448 0 0 1 1.106 4.148v23.646a8.321 8.321 0 0 1-8.3 8.3H376.6a8.253 8.253 0 0 0 7.191 4.148h84.767a8.321 8.321 0 0 0 8.3-8.3V289.6a8.166 8.166 0 0 0-7.471-8.3z",
    transform: "translate(-375.494 -109.553)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-20",
    d: "M456.555 187.05h-68.864a7.23 7.23 0 0 1-7.191-7.191v-12.168a7.23 7.23 0 0 1 7.191-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.23 7.23 0 0 1-7.192 7.19z",
    transform: "translate(-363.906 -139.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-20",
    d: "M456.555 228.35h-68.864a7.23 7.23 0 0 1-7.191-7.191v-12.168a7.23 7.23 0 0 1 7.191-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.142 7.142 0 0 1-7.192 7.19z",
    transform: "translate(-363.906 -123.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-20",
    d: "M456.555 269.612h-68.864a7.23 7.23 0 0 1-7.191-7.191v-12.03a7.23 7.23 0 0 1 7.191-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.031a7.142 7.142 0 0 1-7.192 7.19z",
    transform: "translate(-363.906 -107.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-20",
    d: "M456.555 311.05h-68.864a7.23 7.23 0 0 1-7.191-7.191v-12.168a7.23 7.23 0 0 1 7.191-7.191h68.865a7.23 7.23 0 0 1 7.191 7.191v12.169a7.23 7.23 0 0 1-7.192 7.19z",
    transform: "translate(-363.906 -92.011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(54.483 30.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-21",
    cx: 6.361,
    cy: 6.361,
    r: 6.361
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-21",
    d: "M420.622 214.761a6.344 6.344 0 0 0-6.361-6.361 6.434 6.434 0 0 0-6.361 6.361 6.361 6.361 0 1 0 12.722 0z",
    transform: "translate(-407.9 -151.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-21",
    d: "M420.622 256.161a6.361 6.361 0 1 0-6.361 6.361 6.258 6.258 0 0 0 6.361-6.361z",
    transform: "translate(-407.9 -135.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-21",
    d: "M420.622 297.561a6.361 6.361 0 1 0-6.361 6.361 6.258 6.258 0 0 0 6.361-6.361z",
    transform: "translate(-407.9 -119.453)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-22",
    d: "M416.544 167.4a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.086 8.086 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-407.555 -166.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-22",
    d: "M416.544 208.8a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.085 8.085 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-407.555 -150.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-22",
    d: "M416.544 250.2a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.087 8.087 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.276 6.276 0 0 0-3.734-5.808z",
    transform: "translate(-407.555 -135.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-22",
    d: "M416.544 291.6a6.067 6.067 0 0 1 1.245 3.734 6.344 6.344 0 0 1-6.361 6.361 8.088 8.088 0 0 1-2.627-.553 6.107 6.107 0 0 0 5.116 2.627 6.344 6.344 0 0 0 6.361-6.361 6.424 6.424 0 0 0-3.734-5.808z",
    transform: "translate(-407.555 -119.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    className: "cls-15",
    transform: "translate(496.783)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 41.9,
    cy: 41.9,
    r: 41.9,
    transform: "rotate(-54.212 66.403 33.989)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 35.539,
    cy: 35.539,
    r: 35.539,
    transform: "rotate(-45 74.701 19.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-10",
    cx: 2.489,
    cy: 6.914,
    rx: 2.489,
    ry: 6.914,
    transform: "translate(55.931 20.159)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-10",
    cx: 2.489,
    cy: 6.914,
    rx: 2.489,
    ry: 6.914,
    transform: "translate(55.931 83.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-10",
    d: "M426.414 33.778c-3.872 0-6.914-1.106-6.914-2.489s3.042-2.489 6.914-2.489 6.914 1.106 6.914 2.489-3.18 2.489-6.914 2.489z",
    transform: "translate(-336.189 27.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-10",
    d: "M380.414 33.778c-3.872 0-6.914-1.106-6.914-2.489s3.042-2.489 6.914-2.489 6.914 1.106 6.914 2.489-3.18 2.489-6.914 2.489z",
    transform: "translate(-353.799 27.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-10",
    d: "M420.923 17.543c-2.766 2.766-5.67 4.148-6.638 3.042-.968-.968.415-4.01 3.042-6.638 2.766-2.766 5.67-4.148 6.638-3.042 1.107.969-.276 4.011-3.042 6.638z",
    transform: "translate(-338.304 20.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-10",
    d: "M388.423 50.043c-2.766 2.766-5.67 4.148-6.638 3.042-.968-.968.415-4.01 3.042-6.638 2.766-2.766 5.67-4.148 6.638-3.042 1.107.969-.276 4.011-3.042 6.638z",
    transform: "translate(-350.745 33.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-10",
    d: "M417.348 50.023c-2.766-2.766-4.148-5.67-3.042-6.638.968-.968 4.01.415 6.638 3.042 2.766 2.766 4.148 5.67 3.042 6.638-.83 1.107-3.872-.276-6.638-3.042z",
    transform: "translate(-338.324 33.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-10",
    d: "M384.848 17.523c-2.766-2.766-4.148-5.67-3.042-6.638.968-.968 4.01.415 6.638 3.042 2.766 2.766 4.148 5.67 3.042 6.638-.968 1.107-3.872-.276-6.638-3.042z",
    transform: "translate(-350.765 20.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-10",
    d: "M406.62 31.41a4.01 4.01 0 1 0-4.01 4.01 4.013 4.013 0 0 0 4.01-4.01z",
    transform: "translate(-344.19 27.053)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(56.623 45.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-10",
    d: "M400.2 32.831L417.209 20.8l-15.35 14.1z",
    transform: "translate(-400.2 -20.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(47.772 49.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-10",
    d: "M393.8 23.9l10.648 7.744-1.936 2.074z",
    transform: "translate(-393.8 -23.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    className: "cls-15",
    transform: "translate(71.492 26.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-25",
    d: "M207.406 64.769H57.784a6.138 6.138 0 0 1-6.084-6.085 6.138 6.138 0 0 1 6.084-6.084h149.622a6.138 6.138 0 0 1 6.084 6.084 6.138 6.138 0 0 1-6.084 6.085z",
    transform: "translate(-51.7 9.977)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-25",
    d: "M207.406 64.769H57.784a6.138 6.138 0 0 1-6.084-6.085 6.138 6.138 0 0 1 6.084-6.084h149.622a6.138 6.138 0 0 1 6.084 6.084 6.138 6.138 0 0 1-6.084 6.085z",
    transform: "translate(-51.7 9.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-26",
    d: "M163.4 59.376H78.076A6.787 6.787 0 0 1 71.3 52.6h99.01a6.818 6.818 0 0 1-6.91 6.776z",
    transform: "translate(-44.197 9.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-27",
    d: "M89.211 70.718H78.01a4.013 4.013 0 0 1-4.01-4.01V11.81a4.013 4.013 0 0 1 4.01-4.01h11.2a4.013 4.013 0 0 1 4.01 4.01v54.9a3.847 3.847 0 0 1-4.009 4.008z",
    transform: "translate(-43.163 -7.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-28",
    d: "M126.511 70.718h-11.2a4.013 4.013 0 0 1-4.01-4.01V11.81a4.013 4.013 0 0 1 4.01-4.01h11.2a4.013 4.013 0 0 1 4.01 4.01v54.9a4.013 4.013 0 0 1-4.01 4.008z",
    transform: "translate(-28.884 -7.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-29",
    d: "M140.511 70.718h-11.2a4.013 4.013 0 0 1-4.01-4.01V11.81a4.013 4.013 0 0 1 4.01-4.01h11.2a4.013 4.013 0 0 1 4.01 4.01v54.9a4.013 4.013 0 0 1-4.01 4.008z",
    transform: "translate(-23.524 -7.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-28",
    d: "M114.709 69.232l-11.063 2.213a4.181 4.181 0 0 1-4.84-3.18L88.02 14.473a4.181 4.181 0 0 1 3.18-4.84l11.063-2.213a4.181 4.181 0 0 1 4.84 3.18l10.786 53.792a4.109 4.109 0 0 1-3.18 4.84z",
    transform: "translate(-37.824 -7.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M87.386 70.757h-9.127a300.35 300.35 0 0 1 0-63.057h9.127a369.311 369.311 0 0 1 0 63.057z",
    transform: "translate(-42.168 -7.212)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-31",
    transform: "translate(37.475 .626)",
    d: "M0 0v62.918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-31",
    transform: "translate(40.517 .626)",
    d: "M0 0v62.918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-31",
    transform: "translate(43.421 .765)",
    d: "M0 0v62.78"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-32",
    cx: 4.287,
    cy: 4.287,
    r: 4.287,
    transform: "translate(56.281 6.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-32",
    d: "M89.9 22.71l18.945-4.01 1.245 6.361-18.945 3.872z",
    transform: "translate(-37.076 -3.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-33",
    d: "M92.6 36.31l18.945-4.01 1.245 6.361-18.945 3.872z",
    transform: "translate(-36.043 2.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-33",
    transform: "translate(86.98 .626)",
    d: "M0 0h3.595v63.057H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-34",
    d: "M133.2 46.1a3.661 3.661 0 0 0-3.6 3.6 3.661 3.661 0 0 0 3.6 3.6 3.661 3.661 0 0 0 3.6-3.6 3.57 3.57 0 0 0-3.6-3.6z",
    transform: "translate(-21.878 7.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "cls-34",
    transform: "translate(101.637 48.749)",
    d: "M0 0h19.36v1.659H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(101.637 43.771)",
    fill: "#b7b7b7",
    d: "M0 0h19.36v3.319H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(101.637 32.57)",
    fill: "#bbb",
    d: "M0 0h19.36v9.818H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    className: "cls-15",
    transform: "translate(528.991 156.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-28",
    d: "M461.476 151.484h-71.492a6.049 6.049 0 0 1-6.084-6.084h83.522a5.933 5.933 0 0 1-5.946 6.084z",
    transform: "translate(-382.026 -84.694)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(42.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-19",
    d: "M428.511 164.518h-11.2a4.013 4.013 0 0 1-4.01-4.01v-54.9a4.013 4.013 0 0 1 4.01-4.01h11.2a4.013 4.013 0 0 1 4.01 4.01v54.9a3.924 3.924 0 0 1-4.01 4.01z",
    transform: "translate(-413.3 -101.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    transform: "translate(4.01)",
    fill: "#efefef",
    d: "M0 0h11.201v63.057H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    className: "cls-38",
    transform: "translate(6.638)",
    d: "M0 0v63.057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    className: "cls-38",
    transform: "translate(9.68)",
    d: "M0 0v63.057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "cls-38",
    transform: "translate(12.584)",
    d: "M0 0v63.057"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(61.889 .138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-39",
    d: "M442.511 164.518h-11.2a4.013 4.013 0 0 1-4.01-4.01v-54.9a4.013 4.013 0 0 1 4.01-4.01h11.2a4.013 4.013 0 0 1 4.01 4.01v54.9a3.924 3.924 0 0 1-4.01 4.01z",
    transform: "translate(-427.3 -101.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-29",
    d: "M441.884 108.463h-11.2a1.386 1.386 0 0 1-1.383-1.383 3.129 3.129 0 0 1 3.18-3.18h7.467a3.129 3.129 0 0 1 3.18 3.18 1.271 1.271 0 0 1-1.244 1.383z",
    transform: "translate(-426.534 -100.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-29",
    transform: "translate(0 9.818)",
    d: "M0 0h19.36v1.383H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-29",
    transform: "translate(0 12.584)",
    d: "M0 0h19.36v4.702H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-29",
    d: "M440.256 135.115c0 9.956-2.213 18.115-4.978 18.115s-4.978-8.02-4.978-18.115S432.513 117 435.278 117s4.978 8.159 4.978 18.115z",
    transform: "translate(-426.152 -95.705)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(0 .286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-39",
    d: "M412.628 102.112l10.095 4.978a3.864 3.864 0 0 1 1.8 5.393l-24.2 49.228a3.864 3.864 0 0 1-5.393 1.8l-10.095-4.978a3.864 3.864 0 0 1-1.8-5.393l24.2-49.228a4.093 4.093 0 0 1 5.393-1.8z",
    transform: "translate(-382.544 -101.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-29",
    d: "M387.278 137.829l10.095 4.978a1.221 1.221 0 0 1 .553 1.8 3.277 3.277 0 0 1-4.287 1.521l-6.639-3.32a3.277 3.277 0 0 1-1.521-4.287 1.42 1.42 0 0 1 1.799-.692z",
    transform: "translate(-381.532 -87.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-29",
    transform: "rotate(-153.9 16.6 25.04)",
    d: "M0 0h19.36v1.383H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-29",
    transform: "rotate(-153.9 16.953 23.614)",
    d: "M0 0h19.36v4.702H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-29",
    d: "M398.88 121.51c4.425-8.988 9.956-15.211 12.445-13.967s.968 9.4-3.457 18.392-9.956 15.211-12.445 13.967-.83-9.402 3.457-18.392z",
    transform: "translate(-378.06 -99.533)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    className: "cls-15",
    transform: "translate(12.722 121.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-25",
    d: "M164.906 134.769H15.284a6.138 6.138 0 0 1-6.084-6.085 6.138 6.138 0 0 1 6.084-6.084h149.622a6.138 6.138 0 0 1 6.084 6.084 6.049 6.049 0 0 1-6.084 6.085z",
    transform: "translate(-9.2 -57.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-26",
    d: "M133.183 130.206H26.706A7.583 7.583 0 0 1 19.1 122.6h121.55a7.555 7.555 0 0 1-7.467 7.606z",
    transform: "translate(-5.41 -57.777)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(57.404 28.635)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 18.392,
    cy: 18.392,
    r: 18.392,
    transform: "translate(.398 .372)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-41",
    cx: 15.626,
    cy: 15.626,
    r: 15.626,
    transform: "rotate(-13.133 30.84 3.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 10.509,
    cy: 10.509,
    r: 10.509,
    transform: "rotate(-13.286 50.06 -20.865)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-41",
    d: "M73.834 112.067a7.467 7.467 0 1 0-7.467 7.467 7.35 7.35 0 0 0 7.467-7.467z",
    transform: "translate(-47.578 -93.303)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(17.147 2.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-27",
    d: "M32.386 144.29h-6.361a4.368 4.368 0 0 1-4.425-4.425v-57.94a4.368 4.368 0 0 1 4.425-4.425h6.361a4.368 4.368 0 0 1 4.425 4.425v57.94a4.368 4.368 0 0 1-4.425 4.425z",
    transform: "translate(-21.6 -77.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    className: "cls-43",
    cx: 3.042,
    cy: 6.361,
    rx: 3.042,
    ry: 6.361,
    transform: "translate(4.563 3.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-43",
    transform: "translate(0 19.36)",
    d: "M0 0h15.211v2.904H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    className: "cls-43",
    transform: "translate(0 23.646)",
    d: "M0 0h15.211v1.383H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    className: "cls-43",
    transform: "translate(0 53.654)",
    d: "M0 0h15.211v6.084H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(32.358 17.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-28",
    d: "M48.364 140.194h-12.03a3.718 3.718 0 0 1-3.734-3.734V91.934a3.718 3.718 0 0 1 3.734-3.734h12.03a3.718 3.718 0 0 1 3.736 3.734v44.527a3.809 3.809 0 0 1-3.736 3.733z",
    transform: "translate(-32.6 -88.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-44",
    d: "M36.334 88.3a3.718 3.718 0 0 0-3.734 3.734v44.527a3.718 3.718 0 0 0 3.734 3.734h1.8V88.3z",
    transform: "translate(-32.6 -88.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M44.459 88.3H42.8v51.994h1.659a3.718 3.718 0 0 0 3.734-3.734V91.9a3.785 3.785 0 0 0-3.734-3.6z",
    transform: "translate(-28.695 -88.162)",
    fill: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(88.565 14.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-29",
    d: "M86.319 139.7l11.754-2.351a3.717 3.717 0 0 0 2.9-4.287l-8.708-43.838a3.717 3.717 0 0 0-4.287-2.9l-11.754 2.347a3.717 3.717 0 0 0-2.9 4.287l8.85 43.7a3.425 3.425 0 0 0 4.145 3.042z",
    transform: "translate(-73.247 -86.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-46",
    d: "M75.9 104.4l20.466 3.457.83 4.425L76.73 109.1z",
    transform: "translate(-72.231 -79.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    className: "cls-46",
    cx: 3.872,
    cy: 3.872,
    r: 3.872,
    transform: "translate(6.85 5.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-46",
    d: "M74.7 98.4l20.466 3.457.968 5.393-20.327-3.6z",
    transform: "translate(-72.69 -81.594)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(105.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-44",
    d: "M102.262 142.62l6.223-1.245a4.366 4.366 0 0 0 3.457-5.255l-11.478-56.833a4.433 4.433 0 0 0-5.255-3.457l-6.223 1.245a4.366 4.366 0 0 0-3.457 5.255l11.477 56.834a4.4 4.4 0 0 0 5.256 3.456z",
    transform: "translate(-85.423 -75.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-47",
    d: "M86.3 84.2l16.594 5.255L104 94.986l-16.594-5.393z",
    transform: "translate(-85.087 -72.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-47",
    d: "M87.3 89.2l16.594 5.255L105 99.986l-16.594-5.393z",
    transform: "translate(-84.704 -70.563)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-47",
    cx: 2.351,
    cy: 2.351,
    r: 2.351,
    transform: "translate(5.776 5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-47",
    d: "M104.428 99.7L90.6 107.029l1.521 7.329 13.69-8.02z",
    transform: "translate(-83.441 -66.544)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(345.586 139.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(0 58.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(80.97 257.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-48",
    d: "M345.872 329.208s0 5.531-2.627 9.265-30.422 11.339-32.911 14.243-2.9 7.605 17.009 8.3c17.7.691 23.093-1.659 32.081-5.531 8.02-3.457 1.383-18.392 1.383-18.392a79.464 79.464 0 0 1 .138-9.68c.555-3.322-15.073 1.795-15.073 1.795z",
    transform: "translate(-308.214 -326.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-49",
    d: "M345.771 328.1s.553 10.095-1.659 12.169c-2.074 2.074-21.019 10.924-26.412 12.031",
    transform: "translate(-304.933 -325.598)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(13.458 .843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-50",
    d: "M342.2 326.9v.691",
    transform: "translate(-309.012 -326.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-51",
    d: "M351 328.6c0 3.872-.277 11.892-2.627 14.8-3.319 4.287-22.125 11.339-29.178 13.275",
    transform: "translate(-317.817 -326.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-50",
    d: "M318.891 349.1a5.988 5.988 0 0 0-.691.138",
    transform: "translate(-318.2 -318.401)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-52",
    d: "M322.226 354.722c1.383-4.01-.138-9.68-1.245-12.722-5.393 1.936-9.68 3.6-10.648 4.7-2.212 2.629-2.904 6.639 11.893 8.022z",
    transform: "translate(-308.215 -320.276)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0 16.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-53",
    d: "M359.677 350.807c-8.988 3.872-14.381 6.223-32.082 5.531-14.658-.553-18.253-3.18-18.253-5.67-2.213 2.9-1.521 7.329 17.838 8.02 18.253.691 23.646-1.659 32.911-5.67 5.393-2.351 4.287-9.68 2.9-14.52 1.109 4.565 1.387 10.373-3.314 12.309z",
    transform: "translate(-308.468 -338.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(16.085 26.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-54",
    d: "M321.45 348.151a1.256 1.256 0 0 1-.968-.415 1.13 1.13 0 0 1 .138-1.659 1.966 1.966 0 0 1 .83-.277 1.256 1.256 0 0 1 .968.415 1.129 1.129 0 0 1-.138 1.659 1.965 1.965 0 0 1-.83.277z",
    transform: "translate(-320.067 -345.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-53",
    d: "M321.483 346.015a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383c.277-.138.415-.277.691-.277m0-.415a2.563 2.563 0 0 0-.968.277 1.255 1.255 0 0 0-.415.968 2 2 0 0 0 .277.968 1.57 1.57 0 0 0 1.106.415 2.564 2.564 0 0 0 .968-.277 1.255 1.255 0 0 0 .415-.968 2 2 0 0 0-.277-.968 2.64 2.64 0 0 0-1.106-.415z",
    transform: "translate(-320.1 -345.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-55",
    d: "M321.827 348.591a17.376 17.376 0 0 0-2.627-7.191",
    transform: "translate(-304.359 -320.506)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(19.127 25.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-54",
    d: "M323.65 347.251a1.256 1.256 0 0 1-.968-.415 1.129 1.129 0 0 1 .138-1.659 1.965 1.965 0 0 1 .83-.277 1.256 1.256 0 0 1 .968.415 1.13 1.13 0 0 1-.138 1.659 1.966 1.966 0 0 1-.83.277z",
    transform: "translate(-322.267 -344.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-53",
    d: "M323.683 345.115a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383c.277-.138.415-.277.691-.277m0-.415a2.564 2.564 0 0 0-.968.277 1.255 1.255 0 0 0-.415.968 2 2 0 0 0 .277.968 1.57 1.57 0 0 0 1.106.415 2.563 2.563 0 0 0 .968-.277 1.255 1.255 0 0 0 .415-.968 2 2 0 0 0-.277-.968 2.64 2.64 0 0 0-1.106-.415z",
    transform: "translate(-322.3 -344.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-55",
    d: "M324.027 347.691a17.375 17.375 0 0 0-2.627-7.191",
    transform: "translate(-303.517 -320.851)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(22.094 24.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-54",
    d: "M325.85 346.351a1.256 1.256 0 0 1-.968-.415 1.129 1.129 0 0 1 .138-1.659 1.965 1.965 0 0 1 .83-.277 1.256 1.256 0 0 1 .968.415 1.129 1.129 0 0 1-.138 1.659 1.965 1.965 0 0 1-.83.277z",
    transform: "translate(-324.391 -343.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-53",
    d: "M325.9 344.215a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383c.277-.138.415-.277.691-.277m0-.415a2.564 2.564 0 0 0-.968.277 1.344 1.344 0 0 0-.138 1.936 1.57 1.57 0 0 0 1.106.415 2.564 2.564 0 0 0 .968-.277 1.255 1.255 0 0 0 .415-.968 2 2 0 0 0-.277-.968 1.57 1.57 0 0 0-1.106-.415z",
    transform: "translate(-324.445 -343.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-55",
    d: "M326.227 346.791a17.375 17.375 0 0 0-2.627-7.191",
    transform: "translate(-302.675 -321.195)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(25.136 22.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-54",
    d: "M328.05 345.451a1.256 1.256 0 0 1-.968-.415 1.13 1.13 0 0 1 .138-1.659 1.966 1.966 0 0 1 .83-.277 1.255 1.255 0 0 1 .968.415 1.016 1.016 0 0 1 .277.83 1.2 1.2 0 0 1-.415.83 1.965 1.965 0 0 1-.83.276z",
    transform: "translate(-326.591 -342.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-53",
    d: "M328.1 343.315a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383.761.761 0 0 1 .691-.277m0-.415a2.563 2.563 0 0 0-.968.277 1.344 1.344 0 0 0-.138 1.936 1.57 1.57 0 0 0 1.106.415 2.564 2.564 0 0 0 .968-.277 1.255 1.255 0 0 0 .415-.968 2 2 0 0 0-.277-.968 1.57 1.57 0 0 0-1.106-.415z",
    transform: "translate(-326.645 -342.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-55",
    d: "M328.427 345.891a17.376 17.376 0 0 0-2.627-7.191",
    transform: "translate(-301.833 -321.54)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(29.203 21.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-54",
    d: "M330.912 344.251a1.057 1.057 0 0 1-.691-.277 1.13 1.13 0 0 1-.138-1.659 1.256 1.256 0 0 1 .968-.415 1.056 1.056 0 0 1 .691.277.986.986 0 0 1 .415.83c0 .277 0 .691-.277.83a2.065 2.065 0 0 1-.968.414z",
    transform: "translate(-329.51 -341.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-53",
    d: "M330.988 342.115c.277 0 .415.138.691.277a.934.934 0 0 1 .138 1.383.985.985 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a.934.934 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.258 1.258 0 0 0-1.106.553 1.47 1.47 0 0 0 .138 1.936 1.965 1.965 0 0 0 .83.277 1.258 1.258 0 0 0 1.106-.553 1.47 1.47 0 0 0-.138-1.936 1.169 1.169 0 0 0-.83-.277z",
    transform: "translate(-329.586 -341.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-55",
    d: "M331.787 344.691s-1.521-4.563-4.287-7.191",
    transform: "translate(-301.182 -321.999)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(33.514 18.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-54",
    d: "M334.023 342.589a.832.832 0 0 1-.553-.138.919.919 0 0 1-.553-.691c0-.277-.138-.691 0-.968a1.1 1.1 0 0 1 1.106-.691.831.831 0 0 1 .553.138.919.919 0 0 1 .553.691c0 .277.138.691 0 .968a1.41 1.41 0 0 1-1.106.691z",
    transform: "translate(-332.645 -339.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-53",
    d: "M334.082 340.415a.508.508 0 0 1 .415.138.959.959 0 0 1 .415 1.383.926.926 0 0 1-.968.553.508.508 0 0 1-.415-.138.959.959 0 0 1-.415-1.383.926.926 0 0 1 .968-.553m0-.415a1.417 1.417 0 0 0-.691 2.627 1.036 1.036 0 0 0 .691.138 1.329 1.329 0 0 0 1.245-.83 2.7 2.7 0 0 0 .138-1.106 1.416 1.416 0 0 0-.691-.83c-.277.138-.553 0-.691 0z",
    transform: "translate(-332.703 -340)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-55",
    d: "M335.423 342.914s-2.9-4.84-6.223-6.914",
    transform: "translate(-300.531 -322.573)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(37.462 16.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-54",
    d: "M336.916 340.951h-.277a1.193 1.193 0 0 1-.83-1.521 1.051 1.051 0 0 1 1.106-.83h.277a1.381 1.381 0 0 1 .691.553 2.05 2.05 0 0 1 .138.968 1.052 1.052 0 0 1-1.105.83z",
    transform: "translate(-335.476 -338.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-53",
    d: "M337 338.815h.277a.989.989 0 0 1 .691 1.245 1.04 1.04 0 0 1-.968.691h-.277a.989.989 0 0 1-.691-1.245 1.04 1.04 0 0 1 .968-.691m0-.415a1.665 1.665 0 0 0-1.383.968 1.56 1.56 0 0 0 .138 1.106c.138.415.415.553.83.691H337a1.665 1.665 0 0 0 1.383-.968 1.228 1.228 0 0 0-.968-1.659c-.138 0-.277-.138-.415-.138z",
    transform: "translate(-335.559 -338.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-55",
    d: "M338.82 341.414s-4.563-5.531-8.02-6.914",
    transform: "translate(-299.919 -323.147)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(41.391 13.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-54",
    d: "M339.606 338.551a1.2 1.2 0 0 1-.83-.415 1.016 1.016 0 0 1-.277-.83 1.129 1.129 0 0 1 1.245-1.106 1.255 1.255 0 0 1 .968.415 1.016 1.016 0 0 1 .277.83 1.347 1.347 0 0 1-1.383 1.106z",
    transform: "translate(-338.362 -336.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-53",
    d: "M339.783 336.377a.912.912 0 0 1 .968 1.106.945.945 0 0 1-.968.968h-.138a1.039 1.039 0 1 1 .138-2.074m0-.277a1.364 1.364 0 0 0-1.383 1.245 2 2 0 0 0 .277.968 1.076 1.076 0 0 0 .968.415h.138a1.364 1.364 0 0 0 1.383-1.245 1.386 1.386 0 0 0-1.383-1.383z",
    transform: "translate(-338.4 -336.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-55",
    d: "M342.041 338.67s-5.808-4.978-9.541-5.67",
    transform: "translate(-299.268 -323.722)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(42.635 8.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-54",
    d: "M340.645 335.251a1.33 1.33 0 0 1-1.245-1.106 1.129 1.129 0 0 1 1.106-1.245 1.219 1.219 0 0 1 1.245 1.106 1 1 0 0 1-1.106 1.245z",
    transform: "translate(-339.262 -332.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-53",
    d: "M340.683 333.115a.945.945 0 0 1 .968.968 1.173 1.173 0 0 1-.968 1.106.945.945 0 0 1-.968-.968 1.069 1.069 0 0 1 .968-1.106m0-.415a1.421 1.421 0 0 0-1.383 1.521 1.364 1.364 0 0 0 1.383 1.245 1.249 1.249 0 0 0 1.245-1.521c.138-.553-.415-1.245-1.245-1.245z",
    transform: "translate(-339.3 -332.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-55",
    d: "M342.712 334.7s-4.84-3.457-8.712-3.6",
    transform: "translate(-298.694 -324.449)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(43.029 3.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-54",
    d: "M341.036 331.651a1.1 1.1 0 0 1-1.106-.691 1.119 1.119 0 0 1 .691-1.521c.138 0 .277-.138.415-.138a1.1 1.1 0 0 1 1.106.691 1.119 1.119 0 0 1-.691 1.521.508.508 0 0 1-.415.138z",
    transform: "translate(-339.493 -329.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-53",
    d: "M341.127 329.515a1.04 1.04 0 0 1 .968.691c.138.553 0 1.106-.553 1.245-.138 0-.277.138-.415.138a1.04 1.04 0 0 1-.968-.691c-.138-.553 0-1.106.553-1.245a.508.508 0 0 1 .415-.138m0-.415a.831.831 0 0 0-.553.138 3.667 3.667 0 0 0-.83.691c-.277.277-.138.691 0 1.106a1.329 1.329 0 0 0 1.245.83.831.831 0 0 0 .553-.138 3.666 3.666 0 0 0 .83-.691 1.514 1.514 0 0 0 0-1.106 1.4 1.4 0 0 0-1.245-.83z",
    transform: "translate(-339.585 -329.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-55",
    d: "M342.92 330.424s-4.425-1.936-8.02-.83",
    transform: "translate(-298.349 -325.156)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(133.158 252.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-48",
    d: "M371.917 329.7s1.8 5.116.691 9.541-24.614 21.157-26 24.753-.138 8.159 18.806 1.936c16.87-5.393 21.157-9.542 28.21-16.179 6.361-5.946-5.116-17.838-5.116-17.838a74.194 74.194 0 0 1-3.18-9.127c-.55-3.321-13.411 6.914-13.411 6.914z",
    transform: "translate(-346.208 -322.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-49",
    d: "M371.777 326.5s3.872 9.265 2.627 12.031c-1.245 2.627-15.9 17.424-20.6 20.466",
    transform: "translate(-343.302 -320.445)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(12.849 2.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-50",
    d: "M370.4 323.9a5.817 5.817 0 0 1 .277.691",
    transform: "translate(-349.796 -323.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-51",
    d: "M376.589 325.5c1.383 3.734 3.872 11.2 2.627 14.8-1.659 5.255-16.87 18.253-22.817 22.54",
    transform: "translate(-355.155 -323.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-50",
    d: "M356.191 352.8c-.277.138-.415.277-.691.415",
    transform: "translate(-355.5 -312.836)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-52",
    d: "M360.561 357.977c0-4.287-3.457-8.988-5.531-11.477-4.287 3.6-7.882 6.776-8.435 8.02-1.106 3.319-.277 7.329 13.966 3.457z",
    transform: "translate(-346.191 -312.788)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(.071 14.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-53",
    d: "M393.746 345.56c-7.052 6.776-11.339 10.786-28.21 16.179-13.967 4.563-18.253 3.319-19.083.83-.968 3.457 1.106 7.329 19.5 1.383 17.285-5.531 21.71-9.68 28.9-16.594 4.287-4.01.691-10.509-2.213-14.658 2.489 4.148 4.702 9.4 1.106 12.86z",
    transform: "translate(-346.259 -332.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(14.036 36.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-54",
    d: "M357.722 351.251a.831.831 0 0 1-.553-.138 1.381 1.381 0 0 1-.553-.691 1.214 1.214 0 0 1 .138-.968 1.122 1.122 0 0 1 1.106-.553.831.831 0 0 1 .553.138 1.158 1.158 0 0 1 .415 1.659 1.707 1.707 0 0 1-1.106.553z",
    transform: "translate(-356.282 -348.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-53",
    d: "M357.8 349.115a1.045 1.045 0 0 1 .553.138.959.959 0 0 1 .415 1.383 1.137 1.137 0 0 1-.83.553 1.045 1.045 0 0 1-.553-.138.959.959 0 0 1-.415-1.383.758.758 0 0 1 .83-.553m0-.415a1.452 1.452 0 0 0-1.245.691 1.469 1.469 0 0 0-.138 1.106c.138.415.277.691.691.83a1.036 1.036 0 0 0 .691.138 1.452 1.452 0 0 0 1.245-.691 1.4 1.4 0 0 0-.553-1.936 1.246 1.246 0 0 0-.691-.138z",
    transform: "translate(-356.359 -348.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-55",
    d: "M358.778 351.308a16.234 16.234 0 0 0-4.978-5.808",
    transform: "translate(-343.302 -313.171)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(16.387 34.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-54",
    d: "M359.423 349.651a.832.832 0 0 1-.553-.138 1.158 1.158 0 0 1-.415-1.659 1.122 1.122 0 0 1 1.106-.553.831.831 0 0 1 .553.138 1.381 1.381 0 0 1 .553.691 1.214 1.214 0 0 1-.138.968 1.236 1.236 0 0 1-1.106.553z",
    transform: "translate(-357.983 -347.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-53",
    d: "M359.5 347.515a1.045 1.045 0 0 1 .553.138.959.959 0 0 1 .415 1.383 1.137 1.137 0 0 1-.83.553 1.045 1.045 0 0 1-.553-.138.959.959 0 0 1-.415-1.383.86.86 0 0 1 .83-.553m0-.415a1.452 1.452 0 0 0-1.245.691 1.469 1.469 0 0 0-.138 1.106c.138.415.277.691.691.83a1.036 1.036 0 0 0 .691.138 1.452 1.452 0 0 0 1.245-.691 1.469 1.469 0 0 0 .138-1.106c-.138-.415-.277-.691-.691-.83a1.036 1.036 0 0 0-.691-.138z",
    transform: "translate(-358.059 -347.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-55",
    d: "M360.478 349.708a16.233 16.233 0 0 0-4.978-5.808",
    transform: "translate(-342.651 -313.784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(18.876 32.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-54",
    d: "M361.222 347.951a.831.831 0 0 1-.553-.138 1.381 1.381 0 0 1-.553-.691 1.214 1.214 0 0 1 .138-.968 1.122 1.122 0 0 1 1.106-.553.831.831 0 0 1 .553.138 1.158 1.158 0 0 1 .415 1.659 1.257 1.257 0 0 1-1.106.553z",
    transform: "translate(-359.782 -345.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-53",
    d: "M361.3 345.777a1.045 1.045 0 0 1 .553.138.959.959 0 0 1 .415 1.383 1.137 1.137 0 0 1-.83.553 1.045 1.045 0 0 1-.553-.138.959.959 0 0 1-.415-1.383.934.934 0 0 1 .83-.553m0-.277a1.452 1.452 0 0 0-1.245.691 1.469 1.469 0 0 0-.138 1.106c.138.415.277.691.691.83a1.036 1.036 0 0 0 .691.138 1.452 1.452 0 0 0 1.245-.691 1.4 1.4 0 0 0-.553-1.936 1.246 1.246 0 0 0-.691-.138z",
    transform: "translate(-359.859 -345.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-55",
    d: "M362.278 348.108a16.234 16.234 0 0 0-4.978-5.808",
    transform: "translate(-341.962 -314.396)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(21.228 30.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-54",
    d: "M362.923 346.351a.831.831 0 0 1-.553-.138 1.158 1.158 0 0 1-.415-1.659 1.122 1.122 0 0 1 1.106-.553.831.831 0 0 1 .553.138 1.158 1.158 0 0 1 .415 1.659 1.122 1.122 0 0 1-1.106.553z",
    transform: "translate(-361.484 -343.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-53",
    d: "M363 344.177a1.045 1.045 0 0 1 .553.138.959.959 0 0 1 .415 1.383 1.137 1.137 0 0 1-.83.553 1.045 1.045 0 0 1-.553-.138.959.959 0 0 1-.415-1.383 1.137 1.137 0 0 1 .83-.553m0-.277a1.452 1.452 0 0 0-1.245.691 1.4 1.4 0 0 0 .553 1.936 1.036 1.036 0 0 0 .691.138 1.452 1.452 0 0 0 1.245-.691 1.469 1.469 0 0 0 .138-1.106c-.138-.415-.277-.691-.691-.83a1.036 1.036 0 0 0-.691-.138z",
    transform: "translate(-361.559 -343.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-55",
    d: "M363.978 346.508A16.233 16.233 0 0 0 359 340.7",
    transform: "translate(-341.311 -315.009)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(24.655 27.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-54",
    d: "M365.336 344.251h-.415a1.119 1.119 0 0 1-.691-1.521 1.374 1.374 0 0 1 1.106-.83h.415a1.119 1.119 0 0 1 .691 1.521 1.373 1.373 0 0 1-1.106.83z",
    transform: "translate(-364.004 -341.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-53",
    d: "M365.369 342.115h.277a.989.989 0 0 1 .691 1.245 1.04 1.04 0 0 1-.968.691h-.277a.989.989 0 0 1-.691-1.245 1.04 1.04 0 0 1 .968-.691m0-.415a1.328 1.328 0 0 0-1.245.968 1.438 1.438 0 0 0 .83 1.8c.138 0 .277.138.415.138a1.328 1.328 0 0 0 1.245-.968 1.527 1.527 0 0 0 0-1.106 1.416 1.416 0 0 0-.83-.691.508.508 0 0 0-.415-.138z",
    transform: "translate(-364.037 -341.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-55",
    d: "M366.531 344a14.26 14.26 0 0 0-5.531-4.7",
    transform: "translate(-340.545 -315.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(27.624 23.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-54",
    d: "M367.406 341.689a1.347 1.347 0 0 1-1.106-1.383 1.33 1.33 0 0 1 1.245-1.106h.138a1.2 1.2 0 0 1 .83.415 1.965 1.965 0 0 1 .277.83 1.33 1.33 0 0 1-1.245 1.106z",
    transform: "translate(-366.141 -339.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-53",
    d: "M367.589 339.515c.691.138 1.106.553.968 1.106a.914.914 0 0 1-.968.83h-.138a.886.886 0 0 1-.83-1.106 1.186 1.186 0 0 1 .968-.83m0-.415a1.47 1.47 0 0 0-1.383 1.245 1.373 1.373 0 0 0 1.245 1.521h.138a1.471 1.471 0 0 0 1.383-1.245 1.373 1.373 0 0 0-1.245-1.521z",
    transform: "translate(-366.185 -339.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-55",
    d: "M368.884 341.1a12.255 12.255 0 0 0-6.084-3.6",
    transform: "translate(-339.856 -316.234)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(30.826 20.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-54",
    d: "M369.845 339.151a1.33 1.33 0 0 1-1.245-1.106 1.129 1.129 0 0 1 1.106-1.245 1.219 1.219 0 0 1 1.245 1.106 1.311 1.311 0 0 1-1.106 1.245z",
    transform: "translate(-368.462 -336.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-53",
    d: "M369.883 337.015a.945.945 0 0 1 .968.968 1.173 1.173 0 0 1-.968 1.106.945.945 0 0 1-.968-.968.912.912 0 0 1 .968-1.106m0-.415a1.421 1.421 0 0 0-1.383 1.521 1.364 1.364 0 0 0 1.383 1.245h.138a1.249 1.249 0 0 0 1.245-1.521 1.47 1.47 0 0 0-1.383-1.245z",
    transform: "translate(-368.5 -336.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-55",
    d: "M371.376 338.289a12.6 12.6 0 0 0-6.776-2.489",
    transform: "translate(-339.167 -316.884)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(33.119 15.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-54",
    d: "M371.522 335.951a1.164 1.164 0 0 1-.968-1.8 1.381 1.381 0 0 1 .691-.553h.277a1.164 1.164 0 0 1 .968 1.8.919.919 0 0 1-.691.553z",
    transform: "translate(-370.082 -333.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-53",
    d: "M371.6 333.815a1.04 1.04 0 0 1 .968.691.989.989 0 0 1-.691 1.245h-.277a1.04 1.04 0 0 1-.968-.691.989.989 0 0 1 .691-1.245h.277m0-.415h-.415c-.415.138-.691.277-.83.691a1.469 1.469 0 0 0-.138 1.106 1.374 1.374 0 0 0 1.383.968h.415c.415-.138.691-.277.83-.691a1.469 1.469 0 0 0 .138-1.106 1.374 1.374 0 0 0-1.383-.968z",
    transform: "translate(-370.159 -333.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-55",
    d: "M373.459 334.786s-4.425-1.936-8.159-1.245",
    transform: "translate(-338.899 -317.806)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(32.935 10.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-54",
    d: "M371.336 332.451a1.232 1.232 0 0 1-1.106-.691 1.081 1.081 0 0 1 .691-1.521c.138 0 .277-.138.415-.138a1.232 1.232 0 0 1 1.106.691 1.081 1.081 0 0 1-.691 1.521.508.508 0 0 1-.415.138z",
    transform: "translate(-369.987 -329.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-53",
    d: "M371.373 330.277a1.164 1.164 0 0 1 .968.553 1.01 1.01 0 0 1-.553 1.383c-.138 0-.277.138-.415.138a1.164 1.164 0 0 1-.968-.553 1.01 1.01 0 0 1 .553-1.383.508.508 0 0 1 .415-.138m0-.277a.831.831 0 0 0-.553.138 1.416 1.416 0 0 0-.691.83 1.514 1.514 0 0 0 0 1.106 1.329 1.329 0 0 0 1.245.83.832.832 0 0 0 .553-.138 1.416 1.416 0 0 0 .691-.83 1.515 1.515 0 0 0 0-1.106 1.209 1.209 0 0 0-1.245-.83z",
    transform: "translate(-370.025 -330)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-55",
    d: "M373.105 331.2a13.8 13.8 0 0 0-7.605-.277",
    transform: "translate(-338.823 -318.917)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(31.636 5.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-54",
    d: "M370.406 328.951a.986.986 0 0 1-.83-.415 1.016 1.016 0 0 1-.277-.83 1.2 1.2 0 0 1 .415-.83 1.965 1.965 0 0 1 .83-.277.986.986 0 0 1 .83.415 1.016 1.016 0 0 1 .277.83 1.2 1.2 0 0 1-.415.83 1.965 1.965 0 0 1-.83.277z",
    transform: "translate(-369.004 -326.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-53",
    d: "M370.488 326.815a1.056 1.056 0 0 1 .691.277.924.924 0 0 1-.138 1.383 1 1 0 0 1-1.383 0 .924.924 0 0 1 .138-1.383 1.056 1.056 0 0 1 .691-.277m0-.415a1.388 1.388 0 1 0 .83 2.351 1.337 1.337 0 0 0 0-1.936 1.182 1.182 0 0 0-.83-.415z",
    transform: "translate(-369.086 -326.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-55",
    d: "M371.938 327.409a10.368 10.368 0 0 0-6.638 1.8",
    transform: "translate(-338.899 -320.109)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-56",
    d: "M334.981 317.466c-8.02-1.521-10.924-6.361-9.818-11.892l9.537-88.224c1.106-5.531 9.68-5.531 17.838-4.01 8.02 1.521 20.051 9.68 19.083 15.349l-23.231 81.033c-1.102 5.532-5.39 9.266-13.409 7.744z",
    transform: "translate(-221.193 -111.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-57",
    d: "M386.555 357.5c-4.978 1.936-13.552-.691-15.211-5.116L343 288.216c-1.659-4.425 2.9-7.744 7.882-9.68 4.978-1.936 14.8-.553 16.594 3.872l23.093 64.44c1.656 4.425.964 8.712-4.014 10.652z",
    transform: "translate(-214.412 -87.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-56",
    d: "M347.436 361.2c-5.255.553-11.754-3.457-12.169-8.159l-9.956-69.833c-.553-4.7 4.84-6.638 10.095-7.191 5.255-.553 14.52 3.319 14.934 8.02l5.67 67.758c.414 4.838-3.319 8.848-8.574 9.405z",
    transform: "translate(-221.065 -87.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-57",
    d: "M334.887 210.7h44.389a16.643 16.643 0 0 1 16.594 16.594v2.074a13.932 13.932 0 0 1-.415 3.457 8.915 8.915 0 0 1 .415 2.766l-23.785 75.226c0 8.3-5.393 11.616-13.69 11.616s-11.616-6.361-11.616-14.658l11.063-59.461a2.7 2.7 0 0 0-2.627-2.489l-11.615-5.256c-16.594-9.68-10.648-10.648-13-19.36v-6.5a4.262 4.262 0 0 1 4.287-4.009z",
    transform: "translate(-219.025 -112.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-58",
    d: "M316.3 157.576a84.849 84.849 0 0 1 5.531 13.828 134.214 134.214 0 0 1 3.6 14.243c.968 4.84 2.074 9.68 2.9 14.658.415 2.489.968 4.978 1.245 7.467.415 2.489.691 5.116.968 7.882a45.361 45.361 0 0 1 .277 4.7v1.659a22.457 22.457 0 0 1-.277 2.489 2.563 2.563 0 0 1-.277.968c-.138.415-.277.83-.553 1.521a6.733 6.733 0 0 0-.415.968l-.277.553-.138.277-.277.415c-.138.277-.415.415-.553.691l-.277.277-.277.277-.553.553c-.138.138-.415.415-.553.415l-.691.553c-.83.553-1.521.968-2.074 1.383-.691.415-1.245.691-1.8.968-1.106.691-2.351 1.245-3.457 1.8-4.425 2.351-8.85 4.425-13.275 6.5l-13 6.223c-2.074 1.106-4.287 2.074-6.361 3.181s-4.148 2.213-5.531 3.042l-.553.277a5.983 5.983 0 0 1-7.606-9.127c1.106-1.245 2.213-2.074 3.18-3.042.968-.83 2.074-1.8 3.042-2.489 2.074-1.659 4.01-3.181 5.946-4.563 4.01-2.9 8.02-5.808 12.031-8.573l11.892-8.159c.968-.691 1.936-1.383 2.766-1.936.415-.277.83-.691 1.245-.968a5.266 5.266 0 0 0 .83-.691.135.135 0 0 0-.138.138c-.138 0-.138.138-.277.138l-.138.138-.277.277c-.138.138-.277.415-.415.553l-.415.553-.277.415a1.479 1.479 0 0 1-.415.691 5.69 5.69 0 0 0-.415 1.106c0 .138-.138.415-.138.553a3.879 3.879 0 0 0-.138.691v-.138c-.138-.553-.277-1.521-.415-2.489-.83-4.148-2.074-8.712-3.319-13.275s-2.627-9.127-4.01-13.69-2.766-9.127-3.872-13.828a82.745 82.745 0 0 1-2.351-14.243v-.138a10.585 10.585 0 0 1 9.956-11.339 10.865 10.865 0 0 1 10.376 5.667z",
    transform: "translate(-242.061 -135.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "cls-59",
    d: "M292.3 178.661s.415 3.872 1.245 4.978 20.881-1.106 23.646-5.946l-.968-5.393s-23.508 6.638-23.923 6.361z",
    transform: "translate(-233.687 -127.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "cls-60",
    d: "M292.4 185.635s-11.754-27.242 3.457-33.6c15.073-6.223 21.572 24.061 22.817 27.518 1.105 3.316-24.474 11.06-26.274 6.082z",
    transform: "translate(-235.308 -135.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M365.441 265.223l27.38-14.243c15.073-7.882 15.073-7.882 8.02-22.955l-39-76.332c-4.287-8.159-11.477-12.031-21.572-11.892l-42.591 13c-8.712 4.563-5.116 17.285-.968 25.444l45.357 80.342c8.716 14.242 4.433 16.454 23.374 6.636z",
    transform: "translate(-233.677 -139.797)",
    fill: "#39be66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    className: "cls-58",
    d: "M344.766 147.716c5.67 9.956 8.988 20.742 12.031 31.528l4.84 16.179 2.351 8.02 1.245 3.872.553 1.8.138.553v.415l.138.277.277.553.277.553.138.415.277.83c.138.415.138.83.277 1.245l.138.968.138.83a10.167 10.167 0 0 1 0 2.9c0 1.8-.138 3.319-.277 4.978-.277 3.042-.691 6.084-1.106 8.988-.968 5.808-2.074 11.477-3.457 17.147s-2.9 11.2-4.7 16.87c-.968 2.766-1.936 5.67-3.18 8.435a41.492 41.492 0 0 1-2.074 4.425c-.415.691-.83 1.521-1.383 2.351a12.463 12.463 0 0 1-2.351 2.766 5.965 5.965 0 1 1-8.573-8.3c-.138.138 0-.138.138-.553a9.537 9.537 0 0 1 .553-1.383 25.232 25.232 0 0 0 .968-3.457 717.921 717.921 0 0 0 1.659-7.744c.968-5.255 1.659-10.786 2.351-16.179.553-5.393 1.106-10.924 1.383-16.317.138-2.627.277-5.393.277-7.882a30.084 30.084 0 0 0-.138-3.6c0-.553-.138-.968-.138-1.245v-.138.277c0 .138 0 .138.138.277l.138.415.138.277.138.138v-.138l-.138-.415-.415-.691-.553-1.383-.968-2.074-1.659-4.01-3.18-7.882-6.223-15.764c-4.148-10.509-8.159-21.019-9.818-32.5a10.616 10.616 0 0 1 8.988-12.031 10.865 10.865 0 0 1 10.648 5.393z",
    transform: "translate(-221.16 -138.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-59",
    d: "M329 169.744s.553 3.734 1.521 4.84c.83 1.106 20.742-2.213 23.37-7.191L352.646 162c-.138.138-23.093 7.882-23.646 7.744z",
    transform: "translate(-219.637 -131.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    className: "cls-60",
    d: "M329.388 176.438s-13.137-26.688 1.659-33.741 22.817 22.817 24.2 26.274-23.784 12.307-25.859 7.467z",
    transform: "translate(-221.547 -139.098)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0 104.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    className: "cls-58",
    d: "M283.448 223.1a10.323 10.323 0 0 1-6.776 12.86l-4.287 1.245a10.323 10.323 0 0 1-12.86-6.776 10.323 10.323 0 0 1 6.776-12.86l4.287-1.245a10.323 10.323 0 0 1 12.86 6.776z",
    transform: "translate(-246.407 -215.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    className: "cls-58",
    d: "M277.684 228.876a2.4 2.4 0 0 1-1.659 3.042l-15.349 4.7a2.4 2.4 0 0 1-3.042-1.659 2.4 2.4 0 0 1 1.659-3.042l15.349-4.7a2.635 2.635 0 0 1 3.042 1.659z",
    transform: "translate(-247.004 -211.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    className: "cls-58",
    d: "M272.984 226.676a2.4 2.4 0 0 1-1.659 3.042l-15.349 4.7a2.4 2.4 0 0 1-3.042-1.659 2.4 2.4 0 0 1 1.659-3.042l15.349-4.7a2.635 2.635 0 0 1 3.042 1.659z",
    transform: "translate(-248.803 -212.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    className: "cls-58",
    d: "M270.084 223.992a2.4 2.4 0 0 1-1.659 3.042l-15.349 4.7a2.4 2.4 0 0 1-3.042-1.659 2.4 2.4 0 0 1 1.659-3.042l15.349-4.7a2.294 2.294 0 0 1 3.042 1.659z",
    transform: "translate(-249.914 -213.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-58",
    d: "M270.984 220.092a2.4 2.4 0 0 1-1.659 3.042l-15.349 4.7a2.4 2.4 0 0 1-3.042-1.659 2.4 2.4 0 0 1 1.659-3.042l15.349-4.7a2.293 2.293 0 0 1 3.042 1.659z",
    transform: "translate(-249.569 -214.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-58",
    d: "M275.117 218.366a2.154 2.154 0 0 1-2.213 2.074l-12.031-.553a2.154 2.154 0 0 1-2.074-2.213 2.154 2.154 0 0 1 2.213-2.074l12.031.553a2.158 2.158 0 0 1 2.074 2.213z",
    transform: "translate(-246.512 -215.6)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-58",
    d: "M325.993 172.875a11.021 11.021 0 0 0 4.7-13.275 32.587 32.587 0 0 1-1.245-4.978c-1.245-7.882.138-16.732 1.8-30.56s-13-31.39-36.783-24.2c-23.646 7.329-10.371 57.111-5.116 60.844 5.255 3.872 18.392-1.8 18.392-1.8s2.489 4.7 2.351 6.776c-.14 1.246 4.424 13.692 15.901 7.193z",
    transform: "translate(-238.064 -96.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    className: "cls-62",
    d: "M312.69 118.6a12.824 12.824 0 0 1-1.245 7.606s-1.8 3.457-.277 8.712l.553-1.245s.553 4.148 2.074 4.978l.138-1.936s-.691 2.9 3.319 3.6c0 0-2.9-20.051-4.563-21.71",
    transform: "translate(-226.697 -89.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-62",
    d: "M330.745 139.642h1.383s-.691-1.521-1.106-2.489.83-6.914.83-6.914l1.383 2.351c.968-2.351-.968-8.02-.968-10.371-4.978-1.8-5.531-3.042-8.85-7.191 1.521 1.8-1.936-1.936-2.213-2.351a22.228 22.228 0 0 0-3.042-3.18c-3.319-2.627-7.052-3.457-11.2-4.425-7.744-1.8-11.616-2.074-17.009.968a41 41 0 0 0-11.892 10.924c.968.277 1.383.415 1.245.553a4.08 4.08 0 0 1-2.074.691c-.138.277-.691-3.18-.83-3.042 8.435 2.213 23.923-5.116 25.582-1.106 1.245 3.042 5.808 7.467 8.159 7.467a2.364 2.364 0 0 1 2.213 1.8l1.8 9.4c2.213 3.319 2.766-3.872 3.6-8.85s7.744-4.84 8.435.968 1.383 17.147 2.213 17.977.138 4.7.138 4.7l1.106-1.659-.553 2.9 1.383-1.936a6.951 6.951 0 0 1 1.245 3.457c1.521-1.8-.415-4.563-.415-4.563l2.489-.138c-2.361-.825-3.052-5.941-3.052-5.941z",
    transform: "translate(-239.774 -94.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    className: "cls-62",
    d: "M302.415 117s-1.659 3.042-.968 4.563l.691-.83a12.113 12.113 0 0 0 .691 4.7l.968-1.936s.553 5.255-.553 6.223a4.615 4.615 0 0 0 1.8-3.042c.556-2.349.136-9.263-2.629-9.678z",
    transform: "translate(-230.25 -89.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M281.6 110.467s8.988-15.9 27.795-12.86c22.678 3.6 23.231 25.859 21.157 29.592-.138.001-33.188-13.966-48.952-16.732z",
    transform: "translate(-237.783 -97.22)",
    fill: "#2b8e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M314.982 115.726s-30.975-14.934-41.761-8.02-3.6 17.147 12.445 17.977l.83-8.159c-.138 0-1.106-4.424 28.486-1.798z",
    transform: "translate(-242.956 -93.906)",
    fill: "#bea539"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(159.854 96.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-65",
    d: "M186.042 125.5a95.238 95.238 0 0 1 4.563 13.828c1.245 4.7 2.074 9.4 2.9 14.1s1.8 9.4 2.766 13.967 1.936 9.265 3.181 13.275a17.293 17.293 0 0 0 .83 2.489v.138a4.094 4.094 0 0 1-.415-.553l-.415-.415a4.385 4.385 0 0 0-.83-.691c-.138-.138-.415-.277-.691-.553l-.415-.277-.553-.277c-.277-.138-.415-.277-.691-.277l-.415-.138h-.138c-.138 0-.138 0-.277-.138h-.138a6.222 6.222 0 0 1 1.106.277c.415.138.968.138 1.521.277 1.106.138 2.213.277 3.457.553l14.381 1.8c4.84.553 9.68 1.245 14.658 2.074l7.473 1.241c1.245.277 2.489.553 3.872.83a35.153 35.153 0 0 1 4.287 1.245 6.006 6.006 0 0 1-2.627 11.616h-.553c-1.659-.138-4.01-.138-6.361-.138s-4.7.138-7.052.138l-14.52.415c-4.84.138-9.68.277-14.8.277h-3.872a10.467 10.467 0 0 1-2.074-.138 19.432 19.432 0 0 1-2.489-.277l-.83-.138a5.989 5.989 0 0 0-.691-.138l-.691-.138-.415-.138h-.138l-.415-.138-.83-.415-.415-.138-.277-.138-.553-.277c-.415-.277-.691-.415-.83-.691a4.172 4.172 0 0 1-1.106-1.106 3.666 3.666 0 0 1-.691-.83 24.032 24.032 0 0 1-1.521-2.074 12.159 12.159 0 0 0-.83-1.383c-.83-1.659-1.383-3.042-1.936-4.287-1.106-2.627-1.936-4.978-2.766-7.467s-1.521-4.84-2.351-7.191c-1.383-4.84-2.766-9.541-4.148-14.243s-2.489-9.541-3.457-14.381a86.545 86.545 0 0 1-1.521-14.8 10.683 10.683 0 0 1 10.786-10.648 9.743 9.743 0 0 1 9.956 6.084z",
    transform: "translate(-96.574 -46.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-66",
    d: "M242.915 195.294l-14.52.415c-4.84.138-9.68.277-14.8.277h-3.872a10.466 10.466 0 0 1-2.074-.138 19.432 19.432 0 0 1-2.489-.277l-.83-.138a5.989 5.989 0 0 0-.691-.138l-.691-.138-.415-.138h-.133l-.415-.138-.83-.415-.415-.138-.277-.138-.553-.277c-.415-.277-.691-.415-.83-.691a4.172 4.172 0 0 1-1.106-1.106 3.666 3.666 0 0 1-.691-.83 24.031 24.031 0 0 1-1.521-2.074 12.163 12.163 0 0 0-.83-1.383c-.83-1.659-1.383-3.042-1.936-4.287-1.106-2.627-1.936-4.978-2.766-7.467s-1.521-4.84-2.351-7.191c-1.383-4.84-2.766-9.541-4.148-14.243s-2.489-9.541-3.457-14.381a86.543 86.543 0 0 1-1.521-14.8 10.585 10.585 0 0 1 1.521-5.393 11.4 11.4 0 0 0-4.287-.968 10.771 10.771 0 0 0-10.787 10.649 86.543 86.543 0 0 0 1.521 14.8 135.682 135.682 0 0 0 3.457 14.381c1.245 4.7 2.627 9.541 4.148 14.243.691 2.351 1.521 4.84 2.351 7.191.83 2.489 1.659 4.84 2.766 7.467a53.118 53.118 0 0 0 1.936 4.287c.277.415.415.83.83 1.383a10.618 10.618 0 0 0 1.521 2.074c.138.138.415.553.691.83l1.106 1.106c.277.138.415.415.83.691l.553.277.277.138.415.138.83.415.415.138h.138l.415.138.691.138a5.99 5.99 0 0 1 .691.138l.83.138c.968.138 1.8.138 2.489.277a10.466 10.466 0 0 1 2.074.138h3.872c4.978 0 9.956-.138 14.8-.277l14.52-.415c2.351 0 4.7-.138 7.052-.138 2.213 0 4.7 0 6.361.138h.553a6.094 6.094 0 0 0 6.223-4.01.831.831 0 0 0 .138-.553c-2.216.136-4.567.136-6.779.275z",
    transform: "translate(-96.612 -46.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-67",
    d: "M191.8 140.1s1.383 3.6 1.245 4.978c-.277 1.383-18.945 8.712-23.785 5.67l-1.659-5.255c-.001-.138 23.922-4.978 24.199-5.393z",
    transform: "translate(-95.693 -38.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-68",
    d: "M193.634 146.623s-2.213-29.592-18.53-28.21-8.159 31.252-7.606 34.847c.554 3.734 26.828-1.244 26.136-6.637z",
    transform: "translate(-96.699 -46.966)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(140.906 130.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-65",
    d: "M217.5 174.489a10.216 10.216 0 0 0 10.648 9.818l4.425-.138a10.216 10.216 0 0 0 9.818-10.648 10.216 10.216 0 0 0-10.648-9.818l-4.425.138a10.315 10.315 0 0 0-9.818 10.648z",
    transform: "translate(-217.498 -159.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    className: "cls-65",
    d: "M224.3 177.742a2.365 2.365 0 0 0 2.489 2.351l16.041-.553a2.365 2.365 0 0 0 2.351-2.489 2.365 2.365 0 0 0-2.489-2.351l-16.041.553a2.543 2.543 0 0 0-2.351 2.489z",
    transform: "translate(-214.894 -155.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    className: "cls-65",
    d: "M228 174.142a2.365 2.365 0 0 0 2.489 2.351l16.041-.553a2.365 2.365 0 0 0 2.351-2.489 2.365 2.365 0 0 0-2.489-2.351l-16.041.553a2.365 2.365 0 0 0-2.351 2.489z",
    transform: "translate(-213.477 -156.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    className: "cls-65",
    d: "M229.8 170.542a2.365 2.365 0 0 0 2.489 2.351l16.041-.553a2.365 2.365 0 0 0 2.351-2.489 2.365 2.365 0 0 0-2.489-2.351l-16.041.553a2.543 2.543 0 0 0-2.351 2.489z",
    transform: "translate(-212.788 -158.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    className: "cls-65",
    d: "M227.7 167.142a2.365 2.365 0 0 0 2.489 2.351l16.041-.553a2.365 2.365 0 0 0 2.351-2.489 2.365 2.365 0 0 0-2.489-2.351l-16.041.553a2.44 2.44 0 0 0-2.351 2.489z",
    transform: "translate(-213.595 -159.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    className: "cls-65",
    d: "M222.238 168.129a2.148 2.148 0 0 0 2.762 1.244l11.2-4.425a2.148 2.148 0 0 0 1.245-2.766 2.148 2.148 0 0 0-2.766-1.245l-11.2 4.425a2.148 2.148 0 0 0-1.241 2.767z",
    transform: "translate(-215.736 -160.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(56.528 360.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    className: "cls-48",
    d: "M174.349 330.008s0 5.531 2.627 9.265 30.422 11.339 32.911 14.243 2.9 7.606-17.009 8.3c-17.7.691-23.093-1.659-32.081-5.531-8.02-3.457-1.383-18.392-1.383-18.392a79.465 79.465 0 0 0-.138-9.68c-.415-3.322 15.073 1.795 15.073 1.795z",
    transform: "translate(-156.342 -327.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    className: "cls-49",
    d: "M167.317 328.9s-.553 10.095 1.659 12.169c2.074 2.074 21.019 10.924 26.412 12.031",
    transform: "translate(-152.353 -326.398)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(9.018 .843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    className: "cls-50",
    d: "M163.1 327.7v.691",
    transform: "translate(-162.962 -327.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    className: "cls-51",
    d: "M163 329.3c0 3.872.277 11.892 2.627 14.8 3.319 4.287 22.125 11.339 29.178 13.275",
    transform: "translate(-163 -327.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    className: "cls-50",
    d: "M186.6 349.9a5.988 5.988 0 0 1 .691.138",
    transform: "translate(-153.965 -319.201)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    className: "cls-52",
    d: "M186.753 355.422c-1.383-4.01.138-9.68 1.245-12.722 5.393 1.936 9.68 3.6 10.648 4.7 2.354 2.629 2.903 6.777-11.893 8.022z",
    transform: "translate(-145.1 -321.115)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 16.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    className: "cls-53",
    d: "M160.933 351.607c8.988 3.872 14.381 6.223 32.081 5.531 14.658-.553 18.253-3.18 18.253-5.67 2.213 2.9 1.521 7.329-17.838 8.02-18.253.691-23.646-1.659-32.911-5.67-5.393-2.351-4.287-9.68-2.9-14.52-.972 4.565-1.248 10.373 3.315 12.309z",
    transform: "translate(-156.479 -339.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(36.758 26.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    className: "cls-54",
    d: "M184.445 348.951a1.965 1.965 0 0 1-.83-.277 1.2 1.2 0 0 1-.415-.83 1.482 1.482 0 0 1 .277-.83 1.255 1.255 0 0 1 .968-.415 1.965 1.965 0 0 1 .83.277 1.2 1.2 0 0 1 .415.83 1.483 1.483 0 0 1-.277.83 1.255 1.255 0 0 1-.968.415z",
    transform: "translate(-183.007 -346.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-53",
    d: "M184.5 346.815c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415.917.917 0 0 0-.277.968 1.255 1.255 0 0 0 .415.968 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 2 2 0 0 0-.968-.277z",
    transform: "translate(-183.061 -346.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-55",
    d: "M184.1 349.391a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-145.905 -321.306)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(33.716 25.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-54",
    d: "M182.245 348.051a1.965 1.965 0 0 1-.83-.277 1.2 1.2 0 0 1-.415-.83 1.483 1.483 0 0 1 .277-.83 1.255 1.255 0 0 1 .968-.415 1.965 1.965 0 0 1 .83.277 1.138 1.138 0 0 1 .138 1.659 1.255 1.255 0 0 1-.968.415z",
    transform: "translate(-180.807 -345.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-53",
    d: "M182.3 345.915c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415.917.917 0 0 0-.277.968 1.256 1.256 0 0 0 .415.968 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415.917.917 0 0 0 .277-.968 1.256 1.256 0 0 0-.415-.968 2 2 0 0 0-.968-.277z",
    transform: "translate(-180.861 -345.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-55",
    d: "M181.9 348.491a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-146.747 -321.651)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(30.653 24.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-54",
    d: "M180.05 347.151a1.965 1.965 0 0 1-.83-.277 1.138 1.138 0 0 1-.138-1.659 1.255 1.255 0 0 1 .968-.415 1.965 1.965 0 0 1 .83.277 1.138 1.138 0 0 1 .138 1.659 1.255 1.255 0 0 1-.968.415z",
    transform: "translate(-178.591 -344.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-53",
    d: "M180.1 345.015c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415 1.336 1.336 0 0 0 .138 1.936 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415.917.917 0 0 0 .277-.968c-.138-.277-.138-.691-.415-.968a2 2 0 0 0-.968-.277z",
    transform: "translate(-178.645 -344.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-55",
    d: "M179.7 347.591a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-147.589 -321.995)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(27.61 22.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-54",
    d: "M177.85 346.251a1.966 1.966 0 0 1-.83-.277 1.138 1.138 0 0 1-.138-1.659 1.255 1.255 0 0 1 .968-.415 1.966 1.966 0 0 1 .83.277 1.138 1.138 0 0 1 .138 1.659 2.065 2.065 0 0 1-.968.415z",
    transform: "translate(-176.391 -343.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-53",
    d: "M177.9 344.115c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383.828.828 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415 1.336 1.336 0 0 0 .138 1.936 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 2 2 0 0 0-.968-.277z",
    transform: "translate(-176.445 -343.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-55",
    d: "M177.5 346.691a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-148.431 -322.34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(23.738 21.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-54",
    d: "M174.945 344.951a1.255 1.255 0 0 1-.968-.415 1.965 1.965 0 0 1-.277-.83 1.2 1.2 0 0 1 .415-.83c.277-.138.415-.277.691-.277a1.177 1.177 0 0 1 .83 2.074c-.136.278-.415.278-.691.278z",
    transform: "translate(-173.624 -342.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-53",
    d: "M174.965 342.777a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383 2.335 2.335 0 0 1 .691-.277m0-.277a1.483 1.483 0 0 0-.83.277 1.336 1.336 0 0 0-.138 1.936 1.707 1.707 0 0 0 1.106.553 1.483 1.483 0 0 0 .83-.277 2.229 2.229 0 0 0 .553-.968 2 2 0 0 0-.277-.968 1.689 1.689 0 0 0-1.245-.553z",
    transform: "translate(-173.645 -342.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-55",
    d: "M174.6 345.491s1.521-4.563 4.287-7.191",
    transform: "translate(-149.541 -322.799)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(19.436 18.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-54",
    d: "M171.945 343.389a1.41 1.41 0 0 1-1.106-.691 2.05 2.05 0 0 1-.138-.968 1.381 1.381 0 0 1 .553-.691.831.831 0 0 1 .553-.138 1.41 1.41 0 0 1 1.106.691 1.169 1.169 0 0 1 0 .968 1.173 1.173 0 0 1-.968.83z",
    transform: "translate(-170.471 -340.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-53",
    d: "M172.008 341.215a1.044 1.044 0 0 1 .968.553 1.075 1.075 0 0 1-.415 1.383.508.508 0 0 1-.415.138 1.044 1.044 0 0 1-.968-.553 1.075 1.075 0 0 1 .415-1.383.508.508 0 0 1 .415-.138m0-.415a1.246 1.246 0 0 0-.691.138 1.416 1.416 0 0 0-.691.83 1.083 1.083 0 0 0 .138 1.106 1.589 1.589 0 0 0 1.245.83 1.247 1.247 0 0 0 .691-.138 1.416 1.416 0 0 0 .691-.83 1.083 1.083 0 0 0-.138-1.106 1.329 1.329 0 0 0-1.245-.83z",
    transform: "translate(-170.534 -340.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-55",
    d: "M171.6 343.714s2.9-4.84 6.223-6.914",
    transform: "translate(-150.69 -323.373)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(15.46 16.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-54",
    d: "M169.016 341.751a1.2 1.2 0 0 1-1.106-.83 1.253 1.253 0 0 1 .83-1.521h.277a1.2 1.2 0 0 1 1.106.83 1.253 1.253 0 0 1-.83 1.521z",
    transform: "translate(-167.576 -339.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    className: "cls-53",
    d: "M169.1 339.615a1.04 1.04 0 0 1 .968.691.989.989 0 0 1-.691 1.245h-.277a1.04 1.04 0 0 1-.968-.691.989.989 0 0 1 .691-1.245h.277m0-.415h-.415c-.415.138-.691.277-.83.691a1.469 1.469 0 0 0-.138 1.106 1.374 1.374 0 0 0 1.383.968h.415c.415-.138.691-.277.83-.691a1.469 1.469 0 0 0 .138-1.106 1.665 1.665 0 0 0-1.383-.968z",
    transform: "translate(-167.659 -339.2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-55",
    d: "M168.7 342.114s4.563-5.531 8.02-6.914",
    transform: "translate(-151.8 -323.986)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(11.591 13.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-54",
    d: "M166.245 339.351a1.33 1.33 0 0 1-1.245-1.106 1.483 1.483 0 0 1 .277-.83 1.2 1.2 0 0 1 .83-.415 1.219 1.219 0 0 1 1.245 1.106 1.483 1.483 0 0 1-.277.83.836.836 0 0 1-.83.415z",
    transform: "translate(-164.807 -336.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-53",
    d: "M166.3 337.215a.945.945 0 0 1 .968.968 1.069 1.069 0 0 1-.968 1.106h-.138a.945.945 0 0 1-.968-.968 1.091 1.091 0 0 1 1.106-1.106m0-.415a1.571 1.571 0 0 0-1.106.415.917.917 0 0 0-.277.968 1.364 1.364 0 0 0 1.383 1.245h.138a1.255 1.255 0 0 0 .968-.415.917.917 0 0 0 .277-.968 1.364 1.364 0 0 0-1.383-1.245z",
    transform: "translate(-164.861 -336.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-55",
    d: "M165.9 339.37s5.808-4.978 9.541-5.67",
    transform: "translate(-152.872 -324.56)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(10.262 8.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-54",
    d: "M165.206 336.051a1.2 1.2 0 0 1-.83-.415 1.016 1.016 0 0 1-.277-.83 1.129 1.129 0 0 1 1.245-1.106 1.239 1.239 0 0 1 1.245 1.245 1.489 1.489 0 0 1-1.383 1.106z",
    transform: "translate(-163.823 -333.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    className: "cls-53",
    d: "M165.283 333.915a.98.98 0 0 1 .968 1.106.945.945 0 0 1-.968.968 1.069 1.069 0 0 1-.968-1.106.945.945 0 0 1 .968-.968m0-.415a1.364 1.364 0 0 0-1.383 1.245 1.418 1.418 0 0 0 1.383 1.383 1.364 1.364 0 0 0 1.383-1.245 1.256 1.256 0 0 0-.415-.968 1.077 1.077 0 0 0-.968-.415z",
    transform: "translate(-163.9 -333.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    className: "cls-55",
    d: "M164.9 335.5s4.84-3.457 8.712-3.6",
    transform: "translate(-153.255 -325.249)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(9.882 3.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    className: "cls-54",
    d: "M164.931 332.451a.508.508 0 0 1-.415-.138 1.232 1.232 0 0 1-.691-1.521 1.1 1.1 0 0 1 1.106-.691.508.508 0 0 1 .415.138 1.232 1.232 0 0 1 .691 1.521c-.277.277-.691.691-1.106.691z",
    transform: "translate(-163.582 -329.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    className: "cls-53",
    d: "M164.973 330.315a.508.508 0 0 1 .415.138.873.873 0 0 1 .553 1.245 1.04 1.04 0 0 1-.968.691.508.508 0 0 1-.415-.138.872.872 0 0 1-.553-1.245.885.885 0 0 1 .968-.691m0-.415a1.209 1.209 0 0 0-1.245.83 1.515 1.515 0 0 0 0 1.106 1.416 1.416 0 0 0 .83.691c.138 0 .277.138.553.138a1.209 1.209 0 0 0 1.245-.83 1.515 1.515 0 0 0 0-1.106 1.416 1.416 0 0 0-.83-.691 1.045 1.045 0 0 0-.553-.138z",
    transform: "translate(-163.625 -329.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    className: "cls-55",
    d: "M164.6 331.224s4.425-1.936 8.02-.83",
    transform: "translate(-153.37 -325.956)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(30.531 360.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    className: "cls-48",
    d: "M155.549 330.008s0 5.531 2.627 9.265 30.422 11.339 32.911 14.243 2.9 7.606-17.009 8.3c-17.7.691-23.093-1.659-32.081-5.531-8.02-3.457-1.383-18.392-1.383-18.392a79.465 79.465 0 0 0-.138-9.68c-.415-3.322 15.073 1.795 15.073 1.795z",
    transform: "translate(-137.542 -327.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    className: "cls-49",
    d: "M148.517 328.9s-.553 10.095 1.659 12.169c2.074 2.074 21.019 10.924 26.412 12.031",
    transform: "translate(-133.553 -326.398)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(9.018 .843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    className: "cls-50",
    d: "M144.3 327.7v.691",
    transform: "translate(-144.162 -327.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    className: "cls-51",
    d: "M144.2 329.3c0 3.872.277 11.892 2.627 14.8 3.319 4.287 22.125 11.339 29.178 13.275",
    transform: "translate(-144.2 -327.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    className: "cls-50",
    d: "M167.8 349.9a5.989 5.989 0 0 1 .691.138",
    transform: "translate(-135.165 -319.201)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    className: "cls-52",
    d: "M167.953 355.422c-1.383-4.01.138-9.68 1.245-12.722 5.393 1.936 9.68 3.6 10.648 4.7 2.354 2.629 2.903 6.777-11.893 8.022z",
    transform: "translate(-126.3 -321.115)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 16.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    className: "cls-53",
    d: "M142.133 351.607c8.988 3.872 14.381 6.223 32.081 5.531 14.658-.553 18.253-3.18 18.253-5.67 2.213 2.9 1.521 7.329-17.838 8.02-18.253.691-23.646-1.659-32.911-5.67-5.393-2.351-4.287-9.68-2.9-14.52-.972 4.565-1.248 10.373 3.315 12.309z",
    transform: "translate(-137.679 -339.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(36.758 26.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    className: "cls-54",
    d: "M165.645 348.951a1.965 1.965 0 0 1-.83-.277 1.2 1.2 0 0 1-.415-.83 1.483 1.483 0 0 1 .277-.83 1.255 1.255 0 0 1 .968-.415 1.966 1.966 0 0 1 .83.277 1.2 1.2 0 0 1 .415.83 1.483 1.483 0 0 1-.277.83 1.255 1.255 0 0 1-.968.415z",
    transform: "translate(-164.207 -346.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-53",
    d: "M165.7 346.815c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415.917.917 0 0 0-.277.968 1.255 1.255 0 0 0 .415.968 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 2 2 0 0 0-.968-.277z",
    transform: "translate(-164.261 -346.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    className: "cls-55",
    d: "M165.3 349.391a17.375 17.375 0 0 1 2.627-7.191",
    transform: "translate(-127.105 -321.306)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(33.695 25.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    className: "cls-54",
    d: "M163.45 348.051a1.965 1.965 0 0 1-.83-.277 1.138 1.138 0 0 1-.138-1.659 1.255 1.255 0 0 1 .968-.415 1.965 1.965 0 0 1 .83.277 1.2 1.2 0 0 1 .415.83 1.483 1.483 0 0 1-.277.83 1.255 1.255 0 0 1-.968.415z",
    transform: "translate(-161.991 -345.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    className: "cls-53",
    d: "M163.5 345.915c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383 1.2 1.2 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415 1.336 1.336 0 0 0 .138 1.936 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 2 2 0 0 0-.968-.277z",
    transform: "translate(-162.045 -345.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    className: "cls-55",
    d: "M163.1 348.491a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-127.947 -321.651)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(30.791 24.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    className: "cls-54",
    d: "M161.35 347.151a1.965 1.965 0 0 1-.83-.277 1.138 1.138 0 0 1-.138-1.659 1.255 1.255 0 0 1 .968-.415 1.965 1.965 0 0 1 .83.277 1.2 1.2 0 0 1 .415.83 1.483 1.483 0 0 1-.277.83 1.838 1.838 0 0 1-.968.415z",
    transform: "translate(-159.891 -344.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    className: "cls-53",
    d: "M161.4 345.015c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383.836.836 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415 1.336 1.336 0 0 0 .138 1.936 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 3.517 3.517 0 0 0-.968-.277z",
    transform: "translate(-159.945 -344.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    className: "cls-55",
    d: "M161 347.591a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-128.751 -321.995)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(27.749 22.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    className: "cls-54",
    d: "M159.15 346.251a1.966 1.966 0 0 1-.83-.277 1.138 1.138 0 0 1-.138-1.659 1.255 1.255 0 0 1 .968-.415 1.966 1.966 0 0 1 .83.277 1.138 1.138 0 0 1 .138 1.659c-.415.138-.691.415-.968.415z",
    transform: "translate(-157.691 -343.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "cls-53",
    d: "M159.2 344.115c.277 0 .415.138.691.277a1.064 1.064 0 0 1 .138 1.383.836.836 0 0 1-.83.415c-.277 0-.415-.138-.691-.277a1.064 1.064 0 0 1-.138-1.383.828.828 0 0 1 .83-.415m0-.415a1.57 1.57 0 0 0-1.106.415 1.336 1.336 0 0 0 .138 1.936 1.167 1.167 0 0 0 .968.277 1.57 1.57 0 0 0 1.106-.415 1.336 1.336 0 0 0-.138-1.936 3.517 3.517 0 0 0-.968-.277z",
    transform: "translate(-157.745 -343.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    className: "cls-55",
    d: "M158.8 346.691a17.376 17.376 0 0 1 2.627-7.191",
    transform: "translate(-129.593 -322.34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(23.738 21.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    className: "cls-54",
    d: "M156.145 344.951a1.255 1.255 0 0 1-.968-.415 1.965 1.965 0 0 1-.277-.83 1.2 1.2 0 0 1 .415-.83c.277-.138.415-.277.691-.277a1.177 1.177 0 0 1 .83 2.074c-.136.278-.415.278-.691.278z",
    transform: "translate(-154.824 -342.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    className: "cls-53",
    d: "M156.165 342.777a1.2 1.2 0 0 1 .83.415.924.924 0 0 1-.138 1.383 1.056 1.056 0 0 1-.691.277 1.2 1.2 0 0 1-.83-.415.924.924 0 0 1 .138-1.383 2.335 2.335 0 0 1 .691-.277m0-.277a1.483 1.483 0 0 0-.83.277 1.336 1.336 0 0 0-.138 1.936 1.707 1.707 0 0 0 1.106.553 1.483 1.483 0 0 0 .83-.277 2.229 2.229 0 0 0 .553-.968 2 2 0 0 0-.277-.968 1.689 1.689 0 0 0-1.245-.553z",
    transform: "translate(-154.845 -342.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    className: "cls-55",
    d: "M155.8 345.261a14 14 0 0 1 3.6-6.361",
    transform: "translate(-130.741 -322.569)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(19.436 18.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "cls-54",
    d: "M153.135 343.389a1.41 1.41 0 0 1-1.106-.691 1.169 1.169 0 0 1 0-.968 1.381 1.381 0 0 1 .553-.691.831.831 0 0 1 .553-.138 1.41 1.41 0 0 1 1.106.691 1.169 1.169 0 0 1 0 .968 1.381 1.381 0 0 1-.553.691c-.138 0-.415.138-.553.138z",
    transform: "translate(-151.661 -340.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "cls-53",
    d: "M153.208 341.215a1.044 1.044 0 0 1 .968.553 1.075 1.075 0 0 1-.415 1.383.508.508 0 0 1-.415.138 1.044 1.044 0 0 1-.968-.553 1.075 1.075 0 0 1 .415-1.383.508.508 0 0 1 .415-.138m0-.415a1.246 1.246 0 0 0-.691.138 1.416 1.416 0 0 0-.691.83 1.083 1.083 0 0 0 .138 1.106 1.589 1.589 0 0 0 1.245.83 1.246 1.246 0 0 0 .691-.138 1.416 1.416 0 0 0 .691-.83 1.083 1.083 0 0 0-.138-1.106 1.329 1.329 0 0 0-1.245-.83z",
    transform: "translate(-151.734 -340.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "cls-55",
    d: "M152.8 343.331a12.325 12.325 0 0 1 4.425-5.531",
    transform: "translate(-131.89 -322.99)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(15.46 16.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    className: "cls-54",
    d: "M150.216 341.751a1.2 1.2 0 0 1-1.106-.83 1.253 1.253 0 0 1 .83-1.521h.277a1.2 1.2 0 0 1 1.106.83 1.253 1.253 0 0 1-.83 1.521z",
    transform: "translate(-148.776 -339.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    className: "cls-53",
    d: "M150.3 339.615a1.04 1.04 0 0 1 .968.691.989.989 0 0 1-.691 1.245h-.277a1.04 1.04 0 0 1-.968-.691.989.989 0 0 1 .691-1.245h.277m0-.415h-.415c-.415.138-.691.277-.83.691a1.56 1.56 0 0 0-.138 1.106 1.374 1.374 0 0 0 1.383.968h.415c.415-.138.691-.277.83-.691a1.469 1.469 0 0 0 .138-1.106 1.665 1.665 0 0 0-1.383-.968z",
    transform: "translate(-148.859 -339.2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    className: "cls-55",
    d: "M149.9 341.5a13.278 13.278 0 0 1 5.393-4.7",
    transform: "translate(-133 -323.373)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(11.591 13.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-54",
    d: "M147.445 339.351a1.33 1.33 0 0 1-1.245-1.106 1.483 1.483 0 0 1 .277-.83 1.2 1.2 0 0 1 .83-.415 1.219 1.219 0 0 1 1.245 1.106 1.119 1.119 0 0 1-1.106 1.245z",
    transform: "translate(-146.007 -336.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    className: "cls-53",
    d: "M147.5 337.215a.945.945 0 0 1 .968.968 1.069 1.069 0 0 1-.968 1.106h-.138a.945.945 0 0 1-.968-.968c.138-.553.553-1.106 1.106-1.106m0-.415a1.57 1.57 0 0 0-1.106.415.917.917 0 0 0-.277.968 1.364 1.364 0 0 0 1.383 1.245h.138a1.255 1.255 0 0 0 .968-.415.917.917 0 0 0 .277-.968 1.364 1.364 0 0 0-1.383-1.245z",
    transform: "translate(-146.061 -336.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-55",
    d: "M147.1 338.91s3.6-3.319 7.329-4.01",
    transform: "translate(-134.072 -324.101)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(10.262 8.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-54",
    d: "M146.406 336.051a1.177 1.177 0 1 1 .138-2.351 1.239 1.239 0 0 1 1.245 1.245 1.489 1.489 0 0 1-1.383 1.106z",
    transform: "translate(-145.023 -333.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-53",
    d: "M146.483 333.915a.98.98 0 0 1 .968 1.106.945.945 0 0 1-.968.968 1.069 1.069 0 0 1-.968-1.106.945.945 0 0 1 .968-.968m0-.415a1.364 1.364 0 0 0-1.383 1.245 1.418 1.418 0 0 0 1.383 1.383 1.364 1.364 0 0 0 1.383-1.245 1.256 1.256 0 0 0-.415-.968 1.077 1.077 0 0 0-.968-.415z",
    transform: "translate(-145.1 -333.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-55",
    d: "M146.1 335.3a14.119 14.119 0 0 1 7.052-2.9",
    transform: "translate(-134.455 -325.058)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(9.882 3.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-54",
    d: "M146.131 332.451a.508.508 0 0 1-.415-.138 1.232 1.232 0 0 1-.691-1.521 1.1 1.1 0 0 1 1.106-.691.508.508 0 0 1 .415.138 1.232 1.232 0 0 1 .691 1.521 1.557 1.557 0 0 1-1.106.691z",
    transform: "translate(-144.782 -329.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    className: "cls-53",
    d: "M146.173 330.315a.508.508 0 0 1 .415.138.873.873 0 0 1 .553 1.245 1.04 1.04 0 0 1-.968.691.508.508 0 0 1-.415-.138.872.872 0 0 1-.553-1.245.885.885 0 0 1 .968-.691m0-.415a1.209 1.209 0 0 0-1.245.83 1.515 1.515 0 0 0 0 1.106 1.416 1.416 0 0 0 .83.691c.138 0 .277.138.553.138a1.209 1.209 0 0 0 1.245-.83 1.515 1.515 0 0 0 0-1.106 1.416 1.416 0 0 0-.83-.691 1.045 1.045 0 0 0-.553-.138z",
    transform: "translate(-144.825 -329.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-55",
    d: "M145.8 331.158a10.039 10.039 0 0 1 6.914-.553",
    transform: "translate(-134.57 -325.89)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M167.153 375.284c8.3 0 11.892-6.084 11.892-14.243l8.155-135.932c0-8.3-8.435-10.509-16.732-10.509-8.3 0-21.572 8.435-21.572 16.594l6.638 129.57c.004 8.159 3.461 14.52 11.619 14.52z",
    transform: "translate(-102.852 -10.126)",
    fill: "#004a3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M191.682 205.8h-44.388a16.643 16.643 0 0 0-16.594 16.594v2.074a13.932 13.932 0 0 0 .415 3.457 8.917 8.917 0 0 0-.415 2.766l8.159 135.932c0 8.3 3.734 14.243 11.892 14.243s11.616-6.361 11.616-14.658l6.223-122.795a2.7 2.7 0 0 1 2.627-2.489l11.616-5.255c16.594-9.68 10.648-10.648 13-19.359v-6.5a4.045 4.045 0 0 0-4.151-4.01z",
    transform: "translate(-109.819 -13.495)",
    fill: "#006354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M181.864 256.235h-30.837c-17.009 0-17.009 0-17.7-16.594L124.2 140.77c0-9.127 15.626-21.019 25.306-21.019l36.23-2.351c9.818 0 17.424 9.956 17.424 19.083l-3.6 103.159c-1.241 16.593 3.599 16.593-17.696 16.593z",
    transform: "translate(-112.308 -47.336)",
    fill: "#00b095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M186.286 117.4l3.734 6.084a27.519 27.519 0 0 1 3.734 18.945L182.829 208.8c-1.245 16.594 3.734 28.486-17.562 28.486l-18.391 2.214c-1.106-4.425-3.872-22.955-4.84-27.38-.553-2.627-1.106-5.255-1.521-7.744a34.734 34.734 0 0 1-.553-3.734 32.077 32.077 0 0 1-.277-3.319v-.553.553l.138-.277.138-.691.968-3.734 2.351-7.744 4.7-15.764c.415-1.245.691-2.351 1.106-3.6-.277-3.18-.83-6.5-1.383-9.68-1.383-7.191-3.18-14.243-4.978-21.434a1.056 1.056 0 0 0-.277-.691 12.757 12.757 0 0 0-.691-1.106c-.138.138-1.106-.553-.277-.415 0-.138-.138-.138-.138-.277-.415-.138-.968-.277-.553 0 .138 0 .277.138.415.138a1.07 1.07 0 0 0-.415-.138 21.07 21.07 0 0 1-5.67-3.319c-6.223 7.052-8.988 21.434-9.818 23.785-.138.415.138.968.691 1.521l-.968 4.84c.138 1.106.415 2.074.553 3.042-1.106 4.978-2.074 9.818-3.18 14.8l4.563 48.952c.968 2.489 1.936 5.116 2.9 7.605a266.828 266.828 0 0 0 3.872 9.4c.415 9.541 1.106 12.584 6.5 13.413.138.138.138.277.277.415h41.761c21.3 0 16.594 0 17.7-16.594l3.6-103.159c.278-9.255-7.47-19.211-17.284-19.211z",
    transform: "translate(-112.997 -47.336)",
    opacity: 0.39,
    fill: "#00b095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    className: "cls-65",
    d: "M151.692 134.563c-.691 11.2-4.01 21.71-7.329 32.22l-4.7 15.764-2.351 7.744-.968 3.734-.138.691-.138.277v-.553.553a32.09 32.09 0 0 0 .277 3.319c.138 1.245.415 2.489.553 3.734.415 2.489.968 5.116 1.521 7.744q1.659 7.882 3.734 15.764c1.383 5.255 2.766 10.509 4.425 15.488.83 2.489 1.659 5.116 2.489 7.467.415 1.245.968 2.351 1.383 3.457a12.852 12.852 0 0 0 .691 1.383l.277.553c0 .138.138.138.138.277l.83 3.042a5.554 5.554 0 0 1-3.875 6.779 5.187 5.187 0 0 1-5.255-1.383l-1.245-1.245-.968-1.106a19.788 19.788 0 0 1-1.521-2.074c-.968-1.383-1.659-2.627-2.489-4.01-1.521-2.627-2.766-5.255-4.01-7.744-2.489-5.255-4.7-10.371-6.776-15.626s-4.01-10.509-5.808-16.041c-.83-2.766-1.8-5.393-2.627-8.3-.415-1.383-.83-2.9-1.106-4.287a42.755 42.755 0 0 1-.968-4.84l-.138-1.521v-2.213c0-.415.138-.968.138-1.383l.138-.691.138-1.245c.277-1.659.553-3.042.691-4.425l1.521-8.3c1.106-5.531 2.213-10.924 3.457-16.317 2.213-10.924 4.7-21.71 9.68-31.8a10.637 10.637 0 0 1 14.243-4.84 9.506 9.506 0 0 1 6.084 9.956z",
    transform: "translate(-115.6 -45.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-66",
    d: "M148.717 257.179l-.83-3.042c0-.138 0-.138-.138-.277l-.277-.553a12.847 12.847 0 0 1-.691-1.383c-.415-.968-.968-2.213-1.383-3.457a59.083 59.083 0 0 1-2.489-7.467c-1.659-5.116-3.042-10.233-4.425-15.488s-2.628-10.512-3.734-15.763c-.553-2.627-1.106-5.255-1.521-7.744a34.741 34.741 0 0 1-.553-3.734 32.078 32.078 0 0 1-.277-3.319v-.552.553l.138-.277.138-.691.968-3.734 2.351-7.744 4.7-15.764c3.319-10.509 6.5-21.019 7.329-32.22a10.609 10.609 0 0 0-17.838-8.435 11.465 11.465 0 0 1 5.67.968 10.592 10.592 0 0 1 5.946 10.233c-.691 11.2-4.01 21.71-7.329 32.22l-4.7 15.764-2.351 7.744-.968 3.734-.415.83-.138.277v-.558.553a32.082 32.082 0 0 0 .277 3.319c.138 1.245.415 2.489.553 3.734.415 2.489.968 5.116 1.521 7.744q1.659 7.882 3.734 15.764c1.383 5.255 2.766 10.509 4.425 15.488.83 2.489 1.659 5.116 2.489 7.467.415 1.245.968 2.351 1.383 3.457a12.855 12.855 0 0 0 .691 1.383l.277.553c0 .138.138.138.138.277l.83 3.042a5.728 5.728 0 0 1-.415 4.01 5.185 5.185 0 0 0 2.9 0 5.721 5.721 0 0 0 4.014-6.912z",
    transform: "translate(-111.657 -45.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-67",
    d: "M144.791 150.391s-.553 3.734-1.383 4.84-20.881-1.659-23.508-6.638l1.106-5.393c.139.138 23.37 7.467 23.785 7.191z",
    transform: "translate(-113.954 -37.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-68",
    d: "M146.209 157.176s12.445-26.965-2.489-33.6c-14.934-6.776-22.263 23.37-23.508 26.827-1.244 3.316 24.061 11.751 25.997 6.773z",
    transform: "translate(-113.851 -45.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-65",
    d: "M148.585 139.451a94.966 94.966 0 0 0 1.106-14.243c0-7.744-2.766-16.041-6.5-29.039s7.744-32.081 31.528-28.763 18.668 53.1 14.243 57.525-17.838 1.106-17.838 1.106 2.766 10.371 4.287 10.233c1.383-.138-9.817 21.157-26.826 3.181z",
    transform: "translate(-105.302 -66.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-73",
    d: "M148.157 114.118s-4.978-16.456-5.531-22.125c-.691-5.531 2.074-19.221 19.636-24.061s25.029 5.946 27.656 14.934c-6.638-5.67-24.891 4.7-24.891 4.7l.415 6.361-2.766 3.042 1.659 7.191-2.351.968-3.042-8.574s-3.181-2.351-4.425 1.106c-1.243 3.598-1.517 13.554-6.36 16.458z",
    transform: "translate(-105.29 -66.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-73",
    d: "M159.015 93.9s3.872 7.744 7.744 8.3 10.924-7.606 20.327-2.9c0 0-1.245 14.8-4.148 16.041-2.9 1.383-6.5 2.766-17.285.553s-9.127-21.019-9.127-21.019z",
    transform: "translate(-99.968 -56.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-65",
    d: "M167.613 103.323s3.872-4.563 8.85-4.01 4.7 1.936 4.7 1.936l-1.659 7.744s-2.351 3.872-7.467 1.8a7.025 7.025 0 0 1-4.424-7.47z",
    transform: "translate(-95.706 -54.278)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(22.779 205.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-65",
    d: "M137.642 216.417a10.32 10.32 0 0 0-4.425 13.828l2.074 4.01a10.32 10.32 0 0 0 13.828 4.425 10.32 10.32 0 0 0 4.425-13.828l-2.074-4.01a10.32 10.32 0 0 0-13.828-4.425z",
    transform: "translate(-132.073 -215.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-65",
    d: "M134.36 224.568a2.207 2.207 0 0 0-.968 3.181l7.329 14.243a2.207 2.207 0 0 0 3.18.968 2.207 2.207 0 0 0 .968-3.181l-7.329-14.243a2.393 2.393 0 0 0-3.18-.968z",
    transform: "translate(-131.695 -211.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-65",
    d: "M139.26 226.492a2.207 2.207 0 0 0-.968 3.18l7.329 14.243a2.207 2.207 0 0 0 3.181.968 2.207 2.207 0 0 0 .968-3.181l-7.329-14.243a2.207 2.207 0 0 0-3.181-.967z",
    transform: "translate(-129.819 -211.105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-65",
    d: "M143.26 226.584a2.207 2.207 0 0 0-.968 3.181l7.329 14.243a2.207 2.207 0 0 0 3.18.968 2.207 2.207 0 0 0 .968-3.18l-7.329-14.243a2.311 2.311 0 0 0-3.18-.969z",
    transform: "translate(-128.288 -211.059)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-65",
    d: "M145.36 223.168a2.207 2.207 0 0 0-.968 3.181l7.329 14.243a2.207 2.207 0 0 0 3.18.968 2.207 2.207 0 0 0 .968-3.181l-7.329-14.243a2.393 2.393 0 0 0-3.18-.968z",
    transform: "translate(-127.484 -212.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-65",
    d: "M143.068 218.177a2.058 2.058 0 0 0 .138 3.042l8.85 8.3a2.058 2.058 0 0 0 3.042-.138 2.058 2.058 0 0 0-.138-3.042l-8.85-8.3a2.319 2.319 0 0 0-3.042.138z",
    transform: "translate(-128.096 -214.406)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(98.595 343.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-74",
    d: "M333.025 358.318c0 5.393-39.549 9.818-88.362 9.818s-88.362-4.425-88.362-9.818 39.549-9.818 88.362-9.818 88.362 4.425 88.362 9.818z",
    transform: "translate(-38.76 -205.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-75",
    d: "M276.137 394.469h-76.746L174.5 251.9h126.528z",
    transform: "translate(-31.793 -242.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-74",
    d: "M178.434 274.993c19.5.277 40.24.553 61.674.553 19.636 0 38.719-.138 56.834-.415l4.01-22.678c-19.221-.277-39.687-.553-60.706-.553-22.955 0-44.942.277-65.546.553z",
    transform: "translate(-31.716 -242.773)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    className: "cls-75",
    cx: 208.391,
    cy: 11.892,
    rx: 208.391,
    ry: 11.892
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(10.923 208.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(0 98.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(27.381 120.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(4.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-76",
    d: "M75.15 360.1v-48.4H64.779v48.4L30.9 376.969l2.627 5.393s36.645-20.466 74.119 0l4.7-4.148z",
    transform: "translate(-30.9 -303.818)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 7.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-77",
    d: "M63.835 313.4v48.537l37.2 18.115 2.074-1.8-37.338-18.115V311.6H55.4v1.8z",
    transform: "translate(-21.521 -311.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-77",
    d: "M62.7 348.23v-.83l-31.8 15.9.415.553z",
    transform: "translate(-30.9 -297.895)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 7.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-77",
    d: "M33.666 378.767L67.407 361.9v-48.4h7.743v-1.8H64.779v48.4L30.9 376.969l2.627 5.393 1.383-.691z",
    transform: "translate(-30.9 -311.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-78",
    d: "M64.309 335.523h-6.775a3.718 3.718 0 0 1-3.734-3.734v-16.455a3.718 3.718 0 0 1 3.734-3.734h6.776a3.718 3.718 0 0 1 3.734 3.734v16.456a3.718 3.718 0 0 1-3.735 3.733z",
    transform: "translate(-22.133 -303.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-79",
    d: "M66.245 333.649h-6.637a3.718 3.718 0 0 1-3.734-3.734v-16.456a3.682 3.682 0 0 1 .415-1.659 3.9 3.9 0 0 0-2.489 3.457v16.456a3.718 3.718 0 0 0 3.734 3.734h6.776a3.547 3.547 0 0 0 3.319-2.074 4.091 4.091 0 0 1-1.384.276z",
    transform: "translate(-22.133 -303.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-76",
    d: "M95.221 318.307H46.407A12.334 12.334 0 0 1 34.1 306h73.566a12.545 12.545 0 0 1-12.445 12.307z",
    transform: "translate(-29.675 -306)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 72.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-76",
    d: "M42.081 365.691a7.191 7.191 0 1 0-7.191 7.191 7.142 7.142 0 0 0 7.191-7.191z",
    transform: "translate(-27.7 -358.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    className: "cls-80",
    d: "M38.98 365.04a4.84 4.84 0 1 0-4.84 4.84 4.81 4.81 0 0 0 4.84-4.84z",
    transform: "translate(-27.087 -357.849)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(73.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    className: "cls-76",
    d: "M95.581 365.691a7.191 7.191 0 1 0-7.191 7.191 7.142 7.142 0 0 0 7.191-7.191z",
    transform: "translate(-81.2 -358.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-80",
    d: "M92.58 365.04a4.84 4.84 0 1 0-4.84 4.84 4.9 4.9 0 0 0 4.84-4.84z",
    transform: "translate(-80.549 -357.849)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(22.541 105.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-75",
    d: "M114.637 315.166h-80.2A10.21 10.21 0 0 1 24.2 304.933 10.21 10.21 0 0 1 34.433 294.7h80.342a10.21 10.21 0 0 1 10.233 10.233 10.241 10.241 0 0 1-10.371 10.233z",
    transform: "translate(-24.2 -294.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    className: "cls-81",
    d: "M121.439 307.145a10.748 10.748 0 0 0 .277-2.213 10.21 10.21 0 0 0-10.233-10.232H32.8c18.392 23.785 58.217 16.179 88.639 12.445z",
    transform: "translate(-20.908 -294.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-82",
    d: "M115.6 310.024H35.263a10.21 10.21 0 0 1-10.233-10.233v-.691a10.1 10.1 0 0 0-.83 4.148 10.21 10.21 0 0 0 10.233 10.233h80.342a10.273 10.273 0 0 0 10.233-9.541 10.386 10.386 0 0 1-9.408 6.084z",
    transform: "translate(-24.2 -293.016)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(3.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-75",
    d: "M22.475 224.344l6.914 76.056a6.167 6.167 0 0 1-5.531 6.638 6.167 6.167 0 0 1-6.638-5.531l-6.914-76.057a6.167 6.167 0 0 1 5.531-6.638 5.906 5.906 0 0 1 6.638 5.532z",
    transform: "translate(-10.285 -218.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    className: "cls-83",
    d: "M21.206 224.337a6.167 6.167 0 0 0-6.638-5.531c-.415 0-.691.138-.968.138a6.21 6.21 0 0 1 4.563 5.393l6.914 76.055a6.152 6.152 0 0 1-4.563 6.5 5.271 5.271 0 0 0 2.074.138 6.167 6.167 0 0 0 5.531-6.638z",
    transform: "translate(-9.016 -218.761)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0 33.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    className: "cls-76",
    d: "M35.142 324.863a2.63 2.63 0 0 1-2.9 2.213A27.988 27.988 0 0 1 7.9 299l2.627-50.473A5.82 5.82 0 0 1 16.474 243l-3.042 56a22.294 22.294 0 0 0 19.36 22.4A2.63 2.63 0 0 1 35 324.31z",
    transform: "translate(-7.899 -243)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    className: "cls-84",
    d: "M33.721 325.7a27.835 27.835 0 0 1-24.338-27.932l2.628-50.468a6.51 6.51 0 0 1 1.521-3.6 5.777 5.777 0 0 0-2.9 4.7L8 298.875a28.073 28.073 0 0 0 24.338 28.071 2.413 2.413 0 0 0 2.489-1.245 2.977 2.977 0 0 1-1.106-.001z",
    transform: "translate(-7.861 -242.732)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(30.147 76.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 .138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    className: "cls-76",
    d: "M104.926 318.035a2.774 2.774 0 0 1-2.766-2.766v-1.521c0-18.806-21.572-34.156-47.984-34.156h-7.744c-6.084 0-11.2 3.457-11.2 7.467v23.923a2.774 2.774 0 0 1-2.766 2.766 2.774 2.774 0 0 1-2.766-2.766V287.06c0-7.191 7.467-12.86 16.732-12.86h7.744c29.454 0 53.515 17.838 53.515 39.687v1.521a2.659 2.659 0 0 1-2.765 2.627z",
    transform: "translate(-29.7 -274.2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    className: "cls-85",
    d: "M54.176 274.1h-7.744c-9.265 0-16.732 5.808-16.732 12.86v1.94c0-7.191 7.467-12.86 16.732-12.86h7.744c29.316 0 53.239 17.7 53.377 39.41v-1.659c.138-21.853-23.923-39.691-53.377-39.691z",
    transform: "translate(-29.7 -274.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(13.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    className: "cls-86",
    d: "M58.524 153.4a19.913 19.913 0 0 1 16.456 12.86c4.7 12.169 10.233 8.159 10.233 8.159S80.511 188.8 67.1 179.95c-13.278-8.85-8.576-26.55-8.576-26.55z",
    transform: "translate(-2.658 -145.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    className: "cls-87",
    d: "M55.841 200.6s11.477 5.946 13 8.85-5.116 3.734-5.116 3.734-12.033-2.766-7.884-12.584z",
    transform: "translate(-3.709 -127.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-88",
    d: "M66.358 210.685c4.978 8.3 10.095 16.732 15.211 24.891 2.627 4.01 5.255 8.159 7.882 11.892 1.383 1.936 2.766 3.734 4.01 5.393l.83.968c.277.277.553.553.138.277l-.553-.277a1.46 1.46 0 0 0-.691-.277l-.553-.138c-.277 0-.553-.138-.83-.138h1.383c4.7-.138 9.68-.415 14.52-.691l14.8-.83 14.8-.83c4.978-.277 9.818-.553 15.073-.691a4.722 4.722 0 0 1 4.7 4.563c0 2.351-3.042 2.213-5.393 2.489l-1.521 1.106c-4.563.553-10.924 2.766-15.626 3.6l-10.516 2.208-14.522 2.49c-4.84.83-9.68 1.659-14.8 2.351l-.968.138h-3.18c-.415 0-.691-.138-1.106-.138l-.546-.141-.277-.138-1.245-.415a12.8 12.8 0 0 0-1.383-.691 18.458 18.458 0 0 1-2.627-1.936 21.269 21.269 0 0 1-1.8-1.659 104.65 104.65 0 0 1-5.531-5.946c-3.457-3.872-6.638-7.744-9.818-11.616-6.361-7.744-12.307-15.626-18.392-23.646a11.159 11.159 0 1 1 17.838-13.413 10.036 10.036 0 0 0 .691 1.245z",
    transform: "translate(-7.311 -125.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-87",
    d: "M71.55 210.8s7.744 5.255 7.329 18.806c-.553 13.552 2.351 56.281 5.808 61.4s-20.881 8.3-24.338 2.489C56.754 287.549 32.693 180.38 71.55 210.8z",
    transform: "translate(-5.728 -125.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-89",
    d: "M35.634 235.372s2.766-8.435 7.606-13.272c4.978-4.84 5.393-9.956-2.074-21.572C31.762 185.59 27.2 156 52.643 152.4c25.582-3.6 29.039 20.189 29.039 20.189l-.277 6.084s3.6 5.393 5.531 6.638-3.734 3.18-3.734 3.18 1.8 2.9 1.106 3.319a10.032 10.032 0 0 0-1.521 1.245s2.627 1.659 1.383 2.627a9.268 9.268 0 0 0-1.936 3.734s.691 4.7-1.383 5.808c-.968.553-7.467 1.245-12.307-.277-4.148-1.245-6.5 24.2 6.5 33.741 11.616 8.3-35.4 1.385-39.41-3.316z",
    transform: "translate(-11.85 -145.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-88",
    d: "M46.331 266.38s15.211-4.148 92.373 18.945c2.627.83 6.776 4.7 7.744 7.467 2.627 8.435-14.243 55.866-23.37 81.033-5.531 15.211-5.946 7.052-10.233 7.191-6.361.138 6.5-24.753 4.978-43.7-1.8-22.263 4.148-22.4 8.02-29.869-.138.003-83.107 10.236-79.512-41.067z",
    transform: "translate(-7.059 -102.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-90",
    d: "M60.657 322.982l-9.265-1.8c-16.179-3.18-26.965-18.253-24.061-33.6l5.255-56c.415-29.592 9.265-29.454 24.753-26.412L60.38 210c15.488 3.042 41.346 25.306 17.7 36.092l3.042 64.025c-1.659 8.854-10.922 14.662-20.465 12.865z",
    transform: "translate(-14.471 -125.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-89",
    d: "M30.769 272.42S56.9 252.23 132.13 289.29a14.789 14.789 0 0 1 6.084 5.946c9.4 16.732 44.942 79.927 47.707 89.883 3.18 11.477-9.956 2.489-29.454-27.795-6.914-10.786-27.656-24.476-33.741-39.549a7.46 7.46 0 0 0-6.361-4.563c-19.635-1.935-90.574-10.923-85.596-40.792z",
    transform: "translate(-13.069 -101.731)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-90",
    d: "M97.906 313.989s-.83-32.081 42.729-28.9c0 0-36.368-11.063-60.706-20.466-27.656-10.648-52.129 5.116-52.129 5.116s-24.617 60.844 70.106 44.25z",
    transform: "translate(-15.213 -104.028)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(145.473 256.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-90",
    d: "M135.407 352.574s-5.116 11.754 3.18 12.584c8.159.968 11.892 7.329 15.211 11.2 3.319 4.01 23.785 2.627 24.614 1.8.968-.83-14.934-9.4-14.934-9.4L147.3 349.67l-7.882-16.87s-8.574 4.978-16.317 6.084z",
    transform: "translate(-123.1 -332.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-90",
    d: "M132.116 355.656l6.084 14.381h2.074l-4.148-8.988a5.976 5.976 0 0 1 5.393-5.116c4.981-.833-10.51-2.904-9.403-.277z",
    transform: "translate(-119.67 -324.543)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(99.777 261.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-90",
    d: "M92.607 353.294s-6.5 10.509 1.245 11.754 10.924 7.606 13.828 11.477 22.4 3.734 23.231 2.9c.968-.691-13.69-9.68-13.69-9.68l-10.371-15.207 6.776-13.552s-9.265-2.766-17.009-4.287z",
    transform: "translate(-90.054 -336.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-90",
    d: "M90.71 356.491l5.116 13.966 2.074.138-3.457-8.712a5.6 5.6 0 0 1 5.393-4.563c4.564-.691-9.956-3.32-9.126-.829z",
    transform: "translate(-89.817 -329.526)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M78.6 266.046c-3.18-26.827-4.425-30.422-4.425-30.422s-1.521-23.923-5.808-26.412S51.08 201.606 49.7 200.5c0 0-16.594 1.521-16.456 33.049s-15.626 62.227-10.786 62.642c4.978.415 13 12.584 50.2 9.541-.006.139 9.121-12.859 5.942-39.686zm-31.114-25.72c-9.541 1.8-8.988-18.806-8.988-18.806 3.6-8.02 17.977-12.169 17.977-6.223-.002 5.803.69 23.231-8.99 25.028z",
    transform: "translate(-16.51 -127.162)",
    fill: "#f4efbd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(20.785 81.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-89",
    d: "M51.971 212.058c4.148 8.3 8.574 16.594 13 24.891 2.213 4.148 4.425 8.159 6.776 12.169s4.7 8.02 7.052 11.477c.553.83 1.245 1.659 1.659 2.213l.277.277-.277-.138a2.13 2.13 0 0 0-.968-.415c-.138 0-.277-.138-.553-.138s-.415-.138-.691-.138h-.83c.691 0 1.8-.277 2.9-.415a28.317 28.317 0 0 0 3.319-.691l13.69-2.9c4.563-.968 9.265-2.074 13.967-2.9 2.351-.415 4.7-.968 7.052-1.245a44.3 44.3 0 0 1 7.744-.83 3.968 3.968 0 0 1 .691 7.882h-.277a40.54 40.54 0 0 0-6.223 1.521 61.1 61.1 0 0 0-6.638 2.074c-4.425 1.383-8.85 2.9-13.275 4.425s-8.85 3.042-13.552 4.563c-1.106.415-2.351.691-3.457 1.106a24.407 24.407 0 0 1-4.01.968l-.691.138c-.277 0-.691.138-1.106.138h-1.241c-.415 0-.691-.138-.968-.138-.277-.138-.553-.138-.691-.277a6.083 6.083 0 0 1-1.659-.83 5.727 5.727 0 0 1-1.659-1.245 6.388 6.388 0 0 1-.968-.968 30.278 30.278 0 0 1-2.9-3.18c-3.319-4.01-6.223-7.882-8.988-11.754s-5.531-7.882-8.159-11.754c-5.393-7.882-10.509-15.764-15.764-23.785a10.2 10.2 0 0 1 17.142-11.069c-.138.415.138.691.277.968z",
    transform: "translate(-32.931 -206.431)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M52.056 157.608s1.521-8.435-7.606-9.956-25.029 6.361-21.434 19.083c3.6 12.86 2.766 30.56-5.116 29.869 0 0 4.425 4.01 9.956-1.521 0 0-16.732 17.147-5.531 34.985s1.521 20.742-1.8 20.051c0 0 12.031 2.489 12.031-9.956 0-12.584-3.18-20.466.691-24.476 0 0-2.766 9.127 4.01 10.371 0 0-4.01-3.457.553-9.541 4.563-5.946 10.509-20.189 8.159-34.709-2.21-14.658 2.353-16.594 6.087-24.2z",
    transform: "translate(-17.9 -147.465)",
    fill: "#8f6538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-86",
    d: "M42.817 189.3c.968 2.766 2.213 7.744 2.213 7.744-1.106-4.563 3.18-11.063 3.18-11.063-3.042 7.329.138 20.6 9.68 19.083 9.541-1.383 5.393-8.574 5.393-8.574 1.521 2.766-2.351 6.776-6.084 2.627s2.489-14.381 11.339-20.742C77.25 172.01 72 158.735 72 158.735s.83-5.116-10.371-6.914C50.285 150.3 36.733 172.425 42.817 189.3z",
    transform: "translate(-8.938 -145.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-86",
    d: "M62.648 152.089s-16.041-4.425-26.274 9.265-3.18 31.252 7.882 42.176v-5.393l2.213 1.383-.83-6.223 1.659 2.9s.553-7.191.691-8.85 8.022-36.088 14.659-35.258z",
    transform: "translate(-12.728 -145.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M62.317 200.94s-11.477-.553-18.392-4.84l-4.425 6.914s13.967 6.638 17.7 5.393 5.117-7.467 5.117-7.467z",
    transform: "translate(-9.631 -128.846)",
    fill: "#eee89c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-88",
    d: "M110.371 242.1s10.924-5.255 12.445-5.393 12.86.691 13.552.691 7.191 4.978 8.159 6.776c.83 1.936.83 5.946 0 6.084s-1.245-3.872-1.245-3.872l-3.6-2.9-2.074-.691s2.766 4.425 2.766 5.255.138 5.393-.553 5.393-1.245-2.9-1.383-4.287c-.138-1.521-3.6-4.01-3.6-4.01s2.489 4.287 2.351 5.393c-.138.968.277 3.872-.83 3.734s-1.521-3.872-1.521-3.872-1.936-3.319-2.627-3.734c-.83-.553-8.712.968-12.445.138s-9.4 2.351-10.924 1.936c-1.513-.559-3.311-6.229 1.529-6.641z",
    transform: "translate(16.295 -113.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M50.732 203.659s3.6-6.638 8.988-3.872c0 0 .83 9.541 2.627 11.892s5.946 48.537 5.946 48.537-3.872-22.4-12.031-31.943a11.393 11.393 0 0 1 3.319-6.084c2.9-2.489 1.521-4.563 1.521-4.563s-11.476-5.256-14.242-7.606c-2.489-2.628 3.872-6.361 3.872-6.361z",
    transform: "translate(-7.035 -127.693)",
    fill: "#e8e07b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-89",
    d: "M93.585 244.2s10.924-5.255 12.445-5.393 12.86.691 13.552.691 7.191 4.978 8.159 6.776c.83 1.936.83 5.946 0 6.084s-1.245-3.872-1.245-3.872l-3.6-2.9-2.074-.691s2.766 4.425 2.766 5.255.138 5.393-.553 5.393-1.245-2.9-1.383-4.287c-.138-1.521-3.6-4.01-3.6-4.01s2.489 4.287 2.351 5.393c-.138.968.277 3.872-.83 3.734s-1.521-3.872-1.521-3.872-1.936-3.319-2.627-3.734c-.83-.553-8.712.968-12.445.138s-9.4 2.351-10.924 1.936c-1.656-.559-3.311-6.229 1.529-6.641z",
    transform: "translate(9.85 -112.504)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(98.595 72.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-95",
    d: "M141.824 270.977l29.039-70.386a1.869 1.869 0 0 1 2.213-.968 1.869 1.869 0 0 1 .968 2.213L145 272.222a1.869 1.869 0 0 1-2.213.968 1.869 1.869 0 0 1-.963-2.213z",
    transform: "translate(-69.087 -199.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-96",
    d: "M165.255 255.638H92.519a3.365 3.365 0 0 1-3.319-3.319A3.365 3.365 0 0 1 92.519 249h72.875a3.365 3.365 0 0 1 3.319 3.319 3.31 3.31 0 0 1-3.458 3.319z",
    transform: "translate(-89.2 -180.603)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(384.242 212.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(3.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(35.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-62",
    d: "M384 162s2.9 7.606 6.638 9.127 4.148-5.67 4.148-5.67S386.489 163.936 384 162z",
    transform: "translate(-276.465 -146.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-88",
    d: "M429.712 216.418a92.463 92.463 0 0 1-5.808 13.69 145.815 145.815 0 0 1-7.467 12.722c-2.627 4.148-5.393 8.3-8.159 12.445-1.383 2.074-2.766 4.148-4.287 6.223s-3.042 4.148-4.84 6.361c-.968 1.106-1.8 2.213-3.18 3.6a11.314 11.314 0 0 1-1.245 1.106 10.032 10.032 0 0 1-2.074 1.521 6.011 6.011 0 0 1-.968.553 12.848 12.848 0 0 1-1.383.691 6.74 6.74 0 0 1-.968.415l-.691.138h-.277l-.415.138c-.277 0-.553.138-.83.138h-2.351l-.83-.138a11.1 11.1 0 0 1-2.489-.553c-.691-.138-1.383-.415-2.074-.553-1.245-.415-2.489-.691-3.734-1.106-4.84-1.521-9.4-3.042-13.967-4.7l-13.69-4.7c-2.213-.691-4.563-1.521-6.776-2.213a60.251 60.251 0 0 0-6.084-1.659l-.553-.138c-3.18-.691-3.6-3.872-4.563-7.052-1.659-5.116 50.335 1.521 50.335 1.521 1.106.138 2.351.415 3.457.553a6.2 6.2 0 0 0 1.521.138c.415 0 .968.138 1.106.138h-.968a1.036 1.036 0 0 0-.691.138l-.691.138-.553.138a5.762 5.762 0 0 0-.83.277c-.553.277-.691.277-.968.415a1.049 1.049 0 0 1-.553.277c-.553.277-.553.415-.691.415l.138-.138a17.722 17.722 0 0 0 1.379-2.082c2.351-3.457 4.563-7.744 6.914-11.754 2.351-4.148 4.563-8.3 6.776-12.584s4.425-8.435 7.052-12.584a88.283 88.283 0 0 1 8.435-11.892l.138-.138a10.715 10.715 0 0 1 15.073-1.106 10.4 10.4 0 0 1 3.324 11.201z",
    transform: "translate(-297.149 -130.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-88",
    d: "M353.743 241.864s-13.413-6.084-15.211-6.361c-1.8-.138-15.626 1.106-16.456 1.106s-8.712 6.223-9.68 8.435-.968 7.191.138 7.329 1.521-4.7 1.521-4.7l4.287-3.6 2.489-.83s-3.319 5.531-3.18 6.5c0 .968-.138 6.638.691 6.638s1.383-3.457 1.521-5.255 4.287-4.978 4.287-4.978-2.9 5.393-2.766 6.5c.138 1.245-.277 4.7 1.106 4.563s1.8-4.7 1.8-4.7 2.213-4.01 3.18-4.563 10.648.968 15.211 0c4.563-1.106 11.616 2.627 13.413 2.074 1.659-.967 3.733-7.743-2.351-8.158z",
    transform: "translate(-304.148 -117.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-97",
    d: "M377.628 222.1s-2.351 3.042-2.627 4.425c-.138 1.383 15.626 13.828 21.019 12.445l3.18-4.563c0-.138-21.434-11.892-21.572-12.307z",
    transform: "translate(-279.911 -123.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-98",
    d: "M376.841 226.886s10.786-27.656 26-21.434-1.521 32.22-3.042 35.539c-1.663 3.181-25.171-9.265-22.958-14.105z",
    transform: "translate(-279.262 -129.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-97",
    d: "M397.1 198.5s-5.255 4.287-6.5 7.882c0 0 2.351-3.042 3.319-2.351a9.686 9.686 0 0 1 1.936 2.213s2.351.83 2.351-1.245c-.139-2.074 2.765-3.733-1.106-6.499z",
    transform: "translate(-273.939 -132.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-89",
    d: "M432.32 241.525s-1.936-8.988-6.5-14.381-6.914-19.913 0-30.837c7.744-12.169 12.445-32.5-5.393-37.889-21.849-6.776-29.454 6.638-30.56 12.031-.277 1.659-.83 3.872-.415 4.7l.691.83a2.325 2.325 0 0 1-.415 2.627c-1.659 1.936-5.67 5.67-6.776 7.329-1.245 2.074 4.01 3.872 4.01 3.872s-1.106 3.319-.553 3.872a8.6 8.6 0 0 0 2.9.83s-2.351 1.383-1.245 2.627a5.153 5.153 0 0 1 .968 3.319s-1.245 2.9.415 4.425c2.766 2.489 5.255 1.245 10.095 3.042 3.457 1.245 4.84 13.828-11.616 22.678-12.855 6.915 39.83 15.35 44.394 10.925z",
    transform: "translate(-276.939 -148.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-62",
    d: "M415.723 176.6a13.347 13.347 0 0 1-3.319 6.914s-2.766 2.766-2.9 8.3l.83-.968s-.691 4.01.553 5.393l.691-1.8s-1.521 2.627 2.074 4.425c0-.138 3.18-20.189 2.074-22.263",
    transform: "translate(-266.703 -140.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-62",
    d: "M414 191.585l.968-9.541a2.152 2.152 0 0 0-1.521-2.351c-2.351-.691-6.223-2.489-6.5-5.67-.415-4.7-19.774-1.8-26.135-7.882 0 0 3.18 1.245 4.425.691 1.106-.553-9.956-3.6-7.329-13.967 0 0 6.223 6.361 14.52 6.361 0 0-3.734-1.936-3.6-3.457a17.608 17.608 0 0 0 10.371-.277 8.046 8.046 0 0 0-4.287-2.351s5.946-.691 10.509.553c0 0-2.489-2.9-3.734-3.18a26.608 26.608 0 0 1 15.349 4.01s-2.351-3.18-3.872-3.6a14.454 14.454 0 0 1 9.818 4.01l-.415-3.319a35.363 35.363 0 0 1 3.319 4.425l.138-3.457s1.659.968 3.6 4.563l.691-2.627.415 3.042a7.926 7.926 0 0 1 4.84 1.8l-2.9.277s3.872 1.936 4.287 4.148l-1.8-.277s6.084 8.159 5.255 11.754l-1.659-1.659s1.659 8.712-1.245 14.8l-.277-2.766s-1.245 7.191-4.425 10.924l.691-2.351s-4.148 4.978-4.01 6.084.277 2.766.277 2.766l-1.383-.415s-.83 5.116.968 6.914l-2.349-.69s1.106 3.181-.968 4.425a7.554 7.554 0 0 0-.277-3.734l-1.8 1.521 1.383-2.627-1.659 1.245s1.8-3.457 1.245-4.563 2.076-12.169 3.046-17.977-5.531-8.02-7.744-3.457c-2.35 4.978-4.978 11.754-6.226 7.882z",
    transform: "translate(-278.951 -150.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-62",
    d: "M403.428 166.467s-2.627 2.489-4.563 2.766a8.473 8.473 0 0 0 1.383-2.074s-6.5 2.627-10.648.968c0 0 5.116-2.489 5.946-4.01.83-1.798 7.882-.277 7.882 2.35z",
    transform: "translate(-274.322 -145.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-62",
    d: "M405.742 172.2s-2.489 2.351-2.351 4.148l.83-.553s-1.106 2.9-.691 4.7l1.521-1.521s-.968 5.255-2.351 5.808a4.6 4.6 0 0 0 2.627-2.351c1.245-2.349 2.904-9.125.415-10.231z",
    transform: "translate(-269.307 -142.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M430.4 273.414s-8.159-4.287-90.437 7.329c-2.766.415-7.744 3.734-8.988 6.5-3.872 8.159-.691 56.972 4.7 84.214 3.319 16.456 4.84 8.435 9.4 8.85 6.5.691 3.457-42.868 3.457-41.9 1.659 22.955-.553-25.306-3.457-33.6.004.135 81.037 21.569 85.325-31.393z",
    transform: "translate(-297.42 -103.688)",
    fill: "#224171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M410.928 328.317l9.818-2.074c17.009-3.734 23.646-19.913 20.051-36.507l3.6-69.971a18.443 18.443 0 0 0-15.073-19.083c-7.882-1.383-16.041-1.245-17.977-.277l-8.85 2.489c-16.317 3.457-22.4 8.712-21.572 39.825l7.882 71.768c2.208 9.82 12.164 15.904 22.121 13.83z",
    transform: "translate(-277.673 -131.626)",
    fill: "#c9d6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-101",
    d: "M433.462 294.475l-9.818 2.074c-10.095 2.213-20.051-4.01-22.125-13.828l-7.882-71.768V203.9c-9.542 4.148-13.275 12.584-12.722 37.06l7.882 71.768c2.074 9.68 12.031 15.9 22.125 13.828l9.818-2.074c15.9-3.457 22.678-17.838 20.742-33.188a24.353 24.353 0 0 1-8.02 3.181z",
    transform: "translate(-277.667 -130.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-101",
    d: "M442.1 212.717a10.715 10.715 0 0 0-15.073 1.106l-.138.138a102.646 102.646 0 0 0-8.435 11.892c-2.489 4.148-4.84 8.3-7.052 12.584s-4.563 8.435-6.776 12.584c-2.351 4.01-4.563 8.3-6.914 11.754-.553-.138-1.245-.138-1.8-.277l-13.412-2.35 2.074 19.083c2.213.691 4.425 1.521 6.776 2.213 1.245.415 2.489.691 3.734 1.106.691.138 1.245.415 2.074.553a23.757 23.757 0 0 0 2.489.553l.83.138h2.351a1.753 1.753 0 0 0 .83-.138l.415-.138h.277l.691-.138a6.75 6.75 0 0 0 .968-.415 6.369 6.369 0 0 0 1.383-.691c.277-.138.691-.415.968-.553.968-.691 1.521-1.106 2.074-1.521a8.945 8.945 0 0 1 1.245-1.106c1.383-1.383 2.213-2.489 3.18-3.6 1.8-2.213 3.319-4.287 4.84-6.361s2.9-4.148 4.287-6.223c2.766-4.148 5.531-8.3 8.159-12.445a145.827 145.827 0 0 0 7.467-12.722c1.245-2.489 2.489-4.978 3.6-7.605l.688-14.238v-1.245a11.938 11.938 0 0 0-1.8-1.938zm-39.964 50.473z",
    transform: "translate(-277.04 -127.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M465.626 301.69c5.946-6.638 4.978-23.508-3.6-25.859-13.967-3.734-46.048-4.563-102.191 10.924-2.766.691-4.84 3.18-6.5 5.808-10.509 16.87-42.867 82.278-46.186 92.373-3.872 11.616 4.425 13.413 26.135-15.349 7.882-10.509 30.007-38.719 36.921-54.068a7.823 7.823 0 0 1 6.638-4.425c16.876-.694 72.051 8.849 88.783-9.404z",
    transform: "translate(-306.235 -103.339)",
    fill: "#2d5796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-103",
    d: "M403.963 282.974c1.936-2.074 3.042-5.255 3.6-8.574-15.9 1.659-35.815 5.255-60.568 12.169-2.766.691-4.84 3.18-6.5 5.808-.277.415-.415.83-.691 1.245 22.813 1.244 52.682 1.935 64.159-10.648z",
    transform: "translate(-293.386 -103.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-103",
    d: "M463.66 275.7c1.936 6.084.968 14.381-2.9 18.53-16.594 18.253-71.907 8.574-88.639 9.541a7.488 7.488 0 0 0-6.638 4.425c-6.914 15.211-29.039 43.421-36.921 54.068-9.956 13.137-17.009 19.913-21.434 22.263-3.6 11.339 4.7 12.86 26.274-15.626 7.882-10.509 30.007-38.719 36.921-54.068a7.823 7.823 0 0 1 6.638-4.425c16.732-.83 71.907 8.712 88.639-9.541 5.527-6.084 5.112-21.295-1.94-25.167z",
    transform: "translate(-306.205 -102.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-89",
    d: "M448.679 206.917a10.715 10.715 0 0 0-15.073 1.106 102.654 102.654 0 0 0-8.435 11.892c-2.489 4.148-4.84 8.3-7.052 12.584s-4.563 8.435-6.776 12.584c-2.351 4.01-4.563 8.3-6.914 11.754-.553-.138-1.245-.138-1.8-.277 0 0-47.569-6.084-49.367-6.084-2.627.138-.415 1.659-.968 4.425a5.973 5.973 0 0 0 4.563 7.052l.553.138a51.8 51.8 0 0 1 6.084 1.659c2.213.691 4.425 1.521 6.776 2.213l13.69 4.7c4.563 1.659 9.265 3.18 13.967 4.7 1.245.415 2.489.691 3.734 1.106.691.138 1.245.415 2.074.553a23.755 23.755 0 0 0 2.489.553l.83.138h2.351a1.755 1.755 0 0 0 .83-.138l.415-.138h.277l.691-.138a6.75 6.75 0 0 0 .968-.415 6.375 6.375 0 0 0 1.383-.691c.277-.138.691-.415.968-.553.968-.691 1.521-1.106 2.074-1.521a8.945 8.945 0 0 1 1.245-1.106c1.383-1.383 2.213-2.489 3.18-3.6 1.8-2.213 3.319-4.287 4.84-6.361s2.9-4.148 4.287-6.223c2.766-4.148 5.531-8.3 8.159-12.445a145.831 145.831 0 0 0 7.467-12.722A92.463 92.463 0 0 0 452 217.979a10.612 10.612 0 0 0-3.321-11.062zm-39.825 50.335z",
    transform: "translate(-288.736 -129.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-104",
    d: "M448.9 206.3a11.876 11.876 0 0 1 0 6.223 92.462 92.462 0 0 1-5.808 13.69 145.811 145.811 0 0 1-7.467 12.722c-2.627 4.148-5.393 8.3-8.159 12.445-1.383 2.074-2.766 4.148-4.287 6.223s-3.042 4.148-4.84 6.361c-.968 1.106-1.8 2.213-3.18 3.6a11.308 11.308 0 0 1-1.245 1.106 10.031 10.031 0 0 1-2.074 1.521 6.019 6.019 0 0 1-.968.553 12.852 12.852 0 0 1-1.383.691 6.741 6.741 0 0 1-.968.415l-.691.138-.277.138-.415.138c-.277 0-.553.138-.83.138h-2.351l-.83-.138a11.1 11.1 0 0 1-2.489-.553c-.691-.138-1.383-.415-2.074-.553-1.245-.415-2.489-.691-3.734-1.106-4.84-1.521-9.4-3.042-13.966-4.7l-13.69-4.7c-2.213-.691-4.563-1.521-6.776-2.213a60.27 60.27 0 0 0-6.084-1.659l-.553-.138a8.461 8.461 0 0 1-1.659-.691 6.029 6.029 0 0 0 4.7 5.531l.553.138a51.8 51.8 0 0 1 6.084 1.659c2.213.691 4.425 1.521 6.776 2.213l13.69 4.7c4.563 1.659 9.265 3.18 13.966 4.7 1.245.415 2.489.691 3.734 1.106.691.138 1.245.415 2.074.553a23.757 23.757 0 0 0 2.489.553l.83.138h2.351a1.754 1.754 0 0 0 .83-.138l.415-.138h.277l.691-.138a6.752 6.752 0 0 0 .968-.415 6.375 6.375 0 0 0 1.383-.691c.277-.138.691-.415.968-.553.968-.691 1.521-1.106 2.074-1.521a8.948 8.948 0 0 1 1.245-1.106c1.383-1.383 2.213-2.489 3.18-3.6 1.8-2.213 3.319-4.287 4.84-6.361s2.9-4.148 4.287-6.223c2.766-4.148 5.531-8.3 8.159-12.445a145.816 145.816 0 0 0 7.467-12.722 92.463 92.463 0 0 0 5.808-13.69A11.183 11.183 0 0 0 448.9 206.3z",
    transform: "translate(-288.677 -129.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-89",
    d: "M373.143 242.964s-13.413-6.084-15.211-6.361c-1.8-.138-15.626 1.106-16.456 1.106s-8.712 6.223-9.68 8.435-.968 7.191.138 7.329 1.521-4.7 1.521-4.7l4.287-3.6 2.489-.83s-3.319 5.531-3.18 6.5c0 .968-.138 6.638.691 6.638s1.383-3.457 1.521-5.255 4.287-4.978 4.287-4.978-2.9 5.393-2.766 6.5c.138 1.245-.277 4.7 1.106 4.563s1.8-4.7 1.8-4.7 2.213-4.01 3.18-4.563 10.648.968 15.211 0 11.616 2.627 13.413 2.074c1.659-.829 3.733-7.743-2.351-8.158z",
    transform: "translate(-296.722 -117.488)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(34.383 126.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-104",
    d: "M338.291 242.968c1.245-.415 1.8-.553 1.8-.553l-3.18-.415-4.287 3.6s-.415 4.84-1.521 4.7c.138.691.415 1.245.691 1.245 1.106.138 1.521-4.7 1.521-4.7l4.287-3.6z",
    transform: "translate(-331.1 -242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-104",
    d: "M375.021 247.172c-1.936-.691-1.936-.968-3.042-.553-1.8.691-8.85-3.042-13.413-2.074s-14.243-.553-15.211 0-3.18 4.563-3.18 4.563-.553 4.563-1.8 4.7h-.275c.138.83.415 1.383.968 1.245 1.383-.138 1.8-4.7 1.8-4.7s2.213-4.01 3.18-4.563 10.648.968 15.211 0c4.563-1.106 11.616 2.627 13.413 2.074 1.381-.415 1.52-.139 2.349-.692z",
    transform: "translate(-328.42 -241.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-104",
    d: "M339.448 246.489a14.331 14.331 0 0 0 2.628-2.489s-5.116 2.351-5.393 4.148c-.138 1.659-.691 4.84-1.383 5.255.138.83.277 1.383.553 1.245.83 0 1.383-3.457 1.521-5.255a8.793 8.793 0 0 1 2.074-2.904z",
    transform: "translate(-329.492 -241.234)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-89",
    d: "M396.467 203.477s-2.9 8.85-1.8 10.371c1.106 1.659 13.137-10.648 14.381-14.381 1.109-3.595-12.581 4.01-12.581 4.01z",
    transform: "translate(-272.477 -132.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M394.713 215.289s.691-10.509 3.042-11.063 4.563 1.521 4.563 1.521-5.946 9.818-5.808 13.413c.277 3.458-2.21.83-1.797-3.871z",
    transform: "translate(-272.382 -129.914)",
    fill: "#808da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-97",
    d: "M398.3 205.643s16.179-9.127 17.424-11.2 3.319 2.627 4.148 5.393-14.8 11.754-15.626 12.584c-.968.968-4.978-4.7-7.052-4.425s1.106-2.352 1.106-2.352z",
    transform: "translate(-271.683 -133.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-97",
    d: "M393.1 203.1a37.206 37.206 0 0 1 2.213 10.924c.277 6.084 1.936-7.882.968-12.722a6.68 6.68 0 0 0-3.181 1.798z",
    transform: "translate(-272.982 -130.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-97",
    d: "M402.228 221.2s-2.351 3.042-2.627 4.425c-.138 1.383 15.626 13.828 21.019 12.445l3.18-4.563c0-.138-21.3-11.892-21.572-12.307z",
    transform: "translate(-270.494 -123.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-98",
    d: "M401.441 225.986s10.786-27.656 26-21.434-1.521 32.22-3.042 35.539c-1.663 3.319-25.171-9.265-22.958-14.105z",
    transform: "translate(-269.845 -130.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-62",
    d: "M389.206 169.815l1.521-.415-.138.415 3.18-.138s3.319.83 3.872 1.521c.691.691-1.936-.277-2.627-.277a41.8 41.8 0 0 1-5.531.415c-.415 0-.277-1.521-.277-1.521z",
    transform: "translate(-274.481 -143.211)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(97.021 89.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(8.02 128.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(2.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-76",
    d: "M397.925 366.018V314.3h11.063v51.718l36.23 17.977-2.9 5.808s-39.272-21.849-79.1 0l-5.116-4.425z",
    transform: "translate(-358.1 -305.865)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0 8.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-77",
    d: "M400.138 316.236v51.718l-39.825 19.36-2.213-1.936 39.825-19.36V314.3h11.2v1.936z",
    transform: "translate(-358.1 -314.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-77",
    d: "M396.5 353.33v-.83l34.017 16.87-.277.83z",
    transform: "translate(-343.4 -299.676)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(39.687 8.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-77",
    d: "M431.327 386.03L395.1 368.054v-51.718h-8.3V314.4h11.063v51.718l36.23 17.977-2.9 5.808s-.553-.277-1.521-.83z",
    transform: "translate(-386.8 -314.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-78",
    d: "M389.71 339.782h7.19a4.013 4.013 0 0 0 4.01-4.01V318.21a4.013 4.013 0 0 0-4.01-4.01h-7.19a4.013 4.013 0 0 0-4.01 4.01v17.562a4.013 4.013 0 0 0 4.01 4.01z",
    transform: "translate(-347.534 -305.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-79",
    d: "M387.383 337.77h7.191a4.013 4.013 0 0 0 4.01-4.01V316.2a3.829 3.829 0 0 0-.415-1.8 4.047 4.047 0 0 1 2.627 3.734V335.7a4.013 4.013 0 0 1-4.01 4.01H389.6a4.254 4.254 0 0 1-3.6-2.213 4.091 4.091 0 0 0 1.383.273z",
    transform: "translate(-347.419 -305.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-76",
    d: "M374.137 321.337h52.132a13.131 13.131 0 0 0 13.137-13.137H361a13.131 13.131 0 0 0 13.137 13.137z",
    transform: "translate(-356.99 -308.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 77.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(79.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-76",
    d: "M413.5 372.044a7.744 7.744 0 1 1 7.744 7.744 7.731 7.731 0 0 1-7.744-7.744z",
    transform: "translate(-413.5 -364.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-80",
    d: "M415.3 371.316a5.116 5.116 0 1 1 5.116 5.116 5.2 5.2 0 0 1-5.116-5.116z",
    transform: "translate(-412.811 -363.573)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-76",
    d: "M356.2 372.044a7.744 7.744 0 1 1 7.744 7.744 7.731 7.731 0 0 1-7.744-7.744z",
    transform: "translate(-356.2 -364.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-80",
    d: "M358.1 371.316a5.116 5.116 0 1 1 5.116 5.116 5.1 5.1 0 0 1-5.116-5.116z",
    transform: "translate(-355.473 -363.573)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(0 112.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-75",
    d: "M361.463 318.125H447.2a11.1 11.1 0 0 0 11.063-11.063A11.1 11.1 0 0 0 447.2 296h-85.737a11.1 11.1 0 0 0-11.063 11.063 11.1 11.1 0 0 0 11.063 11.062z",
    transform: "translate(-350.4 -296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-81",
    d: "M350.677 309.413a12.176 12.176 0 0 1-.277-2.351A11.1 11.1 0 0 1 361.463 296H445.4c-19.636 25.582-62.227 17.424-94.723 13.413z",
    transform: "translate(-350.4 -296)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-82",
    d: "M360.456 312.554h85.735a11.1 11.1 0 0 0 11.063-11.063v-.691a12.107 12.107 0 0 1 .968 4.425 11.1 11.1 0 0 1-11.063 11.063h-85.735a10.915 10.915 0 0 1-10.924-10.233 10.8 10.8 0 0 0 9.956 6.499z",
    transform: "translate(-350.362 -294.162)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(107.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-75",
    d: "M435.734 220.952l-7.329 81.172a6.731 6.731 0 0 0 5.946 7.191 6.731 6.731 0 0 0 7.191-5.946l7.329-81.172a6.731 6.731 0 0 0-5.946-7.191 6.731 6.731 0 0 0-7.191 5.946z",
    transform: "translate(-428.386 -214.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-83",
    d: "M435.7 220.952a6.567 6.567 0 0 1 7.191-5.946 3.254 3.254 0 0 1 1.106.277 6.515 6.515 0 0 0-4.84 5.808l-7.329 81.172a6.6 6.6 0 0 0 4.84 6.914 12.1 12.1 0 0 1-2.213.277 6.567 6.567 0 0 1-5.946-7.191z",
    transform: "translate(-428.347 -214.986)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(102.425 35.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-76",
    d: "M424.65 328.433a2.6 2.6 0 0 0 3.042 2.351 29.927 29.927 0 0 0 26-30.007l-2.9-53.93a6.267 6.267 0 0 0-6.361-5.946l3.18 59.876a23.8 23.8 0 0 1-20.748 23.923 2.6 2.6 0 0 0-2.351 3.042z",
    transform: "translate(-424.469 -240.9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-84",
    d: "M426.145 329.409a29.926 29.926 0 0 0 26-30.007l-2.9-53.93a6.561 6.561 0 0 0-1.659-3.872 6.208 6.208 0 0 1 3.18 4.978l2.9 53.93a30.012 30.012 0 0 1-26 30.007 2.809 2.809 0 0 1-2.766-1.383 2.055 2.055 0 0 0 1.245.277z",
    transform: "translate(-424.304 -240.632)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(16.317 81.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 .138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-76",
    d: "M365.1 321.178a2.836 2.836 0 0 0 2.9-2.9v-1.659c0-20.189 22.955-36.507 51.3-36.507h8.3c6.5 0 12.031 3.6 12.031 8.02v25.444a2.836 2.836 0 0 0 2.9 2.9 2.836 2.836 0 0 0 2.9-2.9v-25.448c0-7.606-8.02-13.828-17.838-13.828h-8.3c-31.528 0-57.111 19.083-57.111 42.453v1.659a2.9 2.9 0 0 0 2.918 2.766z",
    transform: "translate(-362.2 -274.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-85",
    d: "M419.311 274.2h8.3c9.818 0 17.838 6.223 17.838 13.828v2.072c0-7.606-8.02-13.828-17.838-13.828h-8.3c-31.39 0-56.834 18.806-57.111 42.038v-1.8c0-23.227 25.582-42.31 57.111-42.31z",
    transform: "translate(-362.2 -274.2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-95",
    d: "M312.405 270.862l-28.9-69.971a1.869 1.869 0 0 0-2.213-.968 1.869 1.869 0 0 0-.968 2.213l28.9 69.971a1.869 1.869 0 0 0 2.213.968 1.745 1.745 0 0 0 .968-2.213z",
    transform: "translate(-280.238 -131.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-96",
    d: "M302.019 255.738h72.46a3.365 3.365 0 0 0 3.319-3.319 3.365 3.365 0 0 0-3.319-3.319h-72.46a3.365 3.365 0 0 0-3.319 3.319 3.365 3.365 0 0 0 3.319 3.319z",
    transform: "translate(-273.171 -112.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0 265.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M322.008 347.722s-3.319 3.872-7.467 4.978-28.486-10.648-32.082-10.095-6.776 3.457 6.914 16.317c12.169 11.339 17.285 13 26.135 15.764 7.744 2.489 12.307-12.169 12.307-12.169a71.175 71.175 0 0 1 6.084-6.776c2.214-2.073-11.891-8.019-11.891-8.019z",
    transform: "translate(-277.299 -342.586)",
    fill: "#a3293a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M47.06 6.795s-5.808 7.467-8.574 7.606-21.572-5.116-26-7.606",
    strokeWidth: 1.025,
    stroke: "#7a1f2c",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(9.724 9.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-108",
    d: "M315.715 349.3a4.091 4.091 0 0 0-.415.553",
    transform: "translate(-273.262 -349.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M41.208 1.521c-2.351 2.766-7.467 8.159-10.924 8.988-4.978.968-22.678-5.531-28.9-8.435",
    strokeDasharray: "1.023 1.023",
    strokeWidth: 0.256,
    stroke: "#fff",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-108",
    d: "M285.591 350.577c-.277-.138-.415-.277-.691-.277",
    transform: "translate(-284.9 -348.917)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-52",
    d: "M285.914 355.569c3.457-1.936 5.808-6.914 6.914-9.68-4.978-1.936-9.127-3.457-10.371-3.18-3.181.277-6.223 2.766 3.457 12.86z",
    transform: "translate(-277.297 -342.552)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0 1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-53",
    d: "M315.94 374.375c-8.712-2.766-13.966-4.425-26.135-15.764-9.956-9.4-10.924-13.552-9.4-15.211-3.319.83-5.531 4.148 7.744 16.594 12.445 11.616 17.7 13.413 26.688 16.179 5.255 1.659 8.988-4.148 10.924-8.435-1.939 3.872-5.261 8.02-9.821 6.637z",
    transform: "translate(-277.868 -343.4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(13.596 9.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-54",
    d: "M288.906 351.712a1.106 1.106 0 1 1 1.106-1.106 1.091 1.091 0 0 1-1.106 1.106z",
    transform: "translate(-287.662 -349.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-53",
    d: "M288.945 349.715a.968.968 0 1 1-.968.968 1.165 1.165 0 0 1 .968-.968m0-.415a1.245 1.245 0 1 0 1.245 1.245c.138-.553-.415-1.245-1.245-1.245z",
    transform: "translate(-287.7 -349.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-110",
    d: "M288.6 352.138a16.974 16.974 0 0 0 2.627-6.638",
    transform: "translate(-273.76 -341.471)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(16.638 10.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-54",
    d: "M291.106 352.412a1.106 1.106 0 1 1 1.106-1.106 1.19 1.19 0 0 1-1.106 1.106z",
    transform: "translate(-289.862 -349.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-53",
    d: "M291.145 350.415a.968.968 0 1 1-.968.968.945.945 0 0 1 .968-.968m0-.415a1.245 1.245 0 1 0 1.245 1.245 1.337 1.337 0 0 0-1.245-1.245z",
    transform: "translate(-289.9 -350)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-110",
    d: "M290.8 352.838a16.974 16.974 0 0 0 2.627-6.638",
    transform: "translate(-272.918 -341.203)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(19.542 11.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-54",
    d: "M293.206 353.112a1.106 1.106 0 1 1 1.106-1.106 1.19 1.19 0 0 1-1.106 1.106z",
    transform: "translate(-291.962 -350.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-53",
    d: "M293.245 351.115a.968.968 0 1 1-.968.968.945.945 0 0 1 .968-.968m0-.415a1.245 1.245 0 1 0 1.245 1.245 1.337 1.337 0 0 0-1.245-1.245z",
    transform: "translate(-292 -350.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-110",
    d: "M292.9 353.538a16.974 16.974 0 0 0 2.627-6.638",
    transform: "translate(-272.114 -340.935)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(22.446 12.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-54",
    d: "M295.306 353.813a1.106 1.106 0 1 1 1.106-1.106 1.19 1.19 0 0 1-1.106 1.106z",
    transform: "translate(-294.062 -351.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-53",
    d: "M295.345 351.815a.968.968 0 1 1-.968.968.945.945 0 0 1 .968-.968m0-.415a1.245 1.245 0 1 0 1.245 1.245 1.337 1.337 0 0 0-1.245-1.245z",
    transform: "translate(-294.1 -351.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-110",
    d: "M295 354.238a16.974 16.974 0 0 0 2.627-6.638",
    transform: "translate(-271.31 -340.667)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(26.158 13.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-54",
    d: "M298.114 354.713a1.173 1.173 0 0 1-1.106-.968 1.019 1.019 0 0 1 .968-1.245h.138a1.173 1.173 0 0 1 1.106.968 1.019 1.019 0 0 1-.968 1.245z",
    transform: "translate(-296.709 -352.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-53",
    d: "M298.189 352.677a1.01 1.01 0 0 1 .968.83c.138.553-.277.968-.83 1.106h-.138a1.01 1.01 0 0 1-.968-.83c-.138-.553.277-.968.83-1.106h.138m0-.277h-.277a1.37 1.37 0 0 0-1.106 1.521 1.311 1.311 0 0 0 1.245 1.106h.277a1.137 1.137 0 0 0 .83-.553 2.563 2.563 0 0 0 .277-.968 1.211 1.211 0 0 0-1.245-1.106z",
    transform: "translate(-296.785 -352.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-110",
    d: "M297.8 355.252a15.758 15.758 0 0 0 1.383-7.052",
    transform: "translate(-270.238 -340.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(30.639 14.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-54",
    d: "M301.336 355.451a1.41 1.41 0 0 1-1.106-.691 1.163 1.163 0 0 1 .553-1.521c.138 0 .277-.138.415-.138a1.41 1.41 0 0 1 1.106.691.882.882 0 0 1 0 .83c-.138.277-.277.553-.553.553-.138.276-.276.276-.415.276z",
    transform: "translate(-299.988 -353.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-53",
    d: "M301.373 353.377a.934.934 0 0 1 .83.553 1.023 1.023 0 0 1-.553 1.245c-.138 0-.277.138-.415.138a.934.934 0 0 1-.83-.553 1.023 1.023 0 0 1 .553-1.245.508.508 0 0 1 .415-.138m0-.277a1.045 1.045 0 0 0-.553.138 1.666 1.666 0 0 0-.691.691 1.181 1.181 0 0 0 0 .968 1.209 1.209 0 0 0 1.245.83 1.045 1.045 0 0 0 .553-.138 1.666 1.666 0 0 0 .691-.691 1.181 1.181 0 0 0 0-.968 1.478 1.478 0 0 0-1.245-.83z",
    transform: "translate(-300.025 -353.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-110",
    d: "M301.038 356.029a17.7 17.7 0 0 0-.138-7.329",
    transform: "translate(-269.051 -340.246)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(34.834 15.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-54",
    d: "M304.308 356.112a1.044 1.044 0 0 1-.968-.553 1.224 1.224 0 0 1 .277-1.521.831.831 0 0 1 .553-.138 1.044 1.044 0 0 1 .968.553 1.224 1.224 0 0 1-.277 1.521c-.138 0-.277.138-.553.138z",
    transform: "translate(-303.006 -353.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-53",
    d: "M304.36 354.115a1.2 1.2 0 0 1 .83.415.9.9 0 0 1-.277 1.245c-.138.138-.277.138-.553.138a1.2 1.2 0 0 1-.83-.415.9.9 0 0 1 .277-1.245 1.045 1.045 0 0 1 .553-.138m0-.415a5.988 5.988 0 0 0-.691.138.934.934 0 0 0-.553.83 1.214 1.214 0 0 0 .138.968 1.258 1.258 0 0 0 1.106.553 5.987 5.987 0 0 0 .691-.138 1.346 1.346 0 0 0 .415-1.8 1.707 1.707 0 0 0-1.106-.553z",
    transform: "translate(-303.059 -353.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-110",
    d: "M304.383 356.652A17.279 17.279 0 0 0 303 349.6",
    transform: "translate(-268.247 -339.901)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(39.454 15.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-54",
    d: "M307.716 356.074a1.965 1.965 0 0 1-.83-.277 1.085 1.085 0 0 1 0-1.521 1.016 1.016 0 0 1 .83-.277 1.965 1.965 0 0 1 .83.277 1.085 1.085 0 0 1 0 1.521 1.965 1.965 0 0 1-.83.277z",
    transform: "translate(-306.333 -353.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-53",
    d: "M307.783 354.115c.277 0 .415.138.691.277a.924.924 0 0 1 0 1.383 1.056 1.056 0 0 1-.691.277c-.277 0-.415-.138-.691-.277a.924.924 0 0 1 0-1.383c.277-.138.415-.277.691-.277m0-.415a1.256 1.256 0 0 0-.968.415 1.179 1.179 0 0 0 0 1.8 1.369 1.369 0 1 0 1.936-1.936 2 2 0 0 0-.968-.276z",
    transform: "translate(-306.4 -353.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-110",
    d: "M308.319 356.652A22.06 22.06 0 0 0 305 349.6",
    transform: "translate(-267.482 -339.901)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(43.465 13.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-54",
    d: "M310.506 354.313a1.056 1.056 0 0 1-.691-.277.76.76 0 0 1-.415-.691 1.016 1.016 0 0 1 .277-.83 1.2 1.2 0 0 1 .83-.415 1.056 1.056 0 0 1 .691.277.987.987 0 0 1 .138 1.521 1.2 1.2 0 0 1-.83.415z",
    transform: "translate(-309.262 -351.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-53",
    d: "M310.545 352.415a.831.831 0 0 1 .553.138.924.924 0 0 1 .138 1.383.76.76 0 0 1-.691.415.831.831 0 0 1-.553-.138.924.924 0 0 1-.138-1.383c0-.415.415-.415.691-.415m0-.415a.926.926 0 0 0-.968.553 1.167 1.167 0 0 0-.277.968 1.137 1.137 0 0 0 .553.83 1.966 1.966 0 0 0 .83.277.926.926 0 0 0 .968-.553 1.311 1.311 0 0 0-.277-1.8 1.965 1.965 0 0 0-.83-.277z",
    transform: "translate(-309.3 -352)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-110",
    d: "M311.272 354.7a19.747 19.747 0 0 0-3.872-6.5",
    transform: "translate(-266.563 -340.437)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(46.697 9.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-54",
    d: "M312.935 351.974h-.415a1.381 1.381 0 0 1-.691-.553.882.882 0 0 1 0-.83 1.1 1.1 0 0 1 1.106-.691h.415a1.141 1.141 0 0 1 .691 1.383 1.1 1.1 0 0 1-1.106.691z",
    transform: "translate(-311.604 -349.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-53",
    d: "M312.969 350.015h.277c.553.138.691.691.553 1.245a1.021 1.021 0 0 1-.83.691h-.277c-.553-.138-.691-.691-.553-1.245a.876.876 0 0 1 .83-.691m0-.415a1.4 1.4 0 0 0-1.245.83 1.288 1.288 0 0 0 .83 1.659c.138 0 .277.138.415.138a1.4 1.4 0 0 0 1.245-.83 1.288 1.288 0 0 0-.83-1.659c-.138 0-.277-.138-.415-.138z",
    transform: "translate(-311.637 -349.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-110",
    d: "M313.825 352.016a9.765 9.765 0 0 0-4.425-5.116",
    transform: "translate(-265.797 -340.935)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(44.9 266.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M343.148 345.415s-.277 7.329-2.351 10.924-26.965 12.445-29.039 15.211-4.01 6.361 14.243 6.5c16.179 0 12.584-4.563 26.274-5.67 8.988-.691 5.531-17.009 5.531-17.009s-.138-8.159 0-11.063c.138-3.042-14.658 1.107-14.658 1.107z",
    transform: "translate(-310.289 -343.194)",
    fill: "#7a1f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M345.982 344.1s.415 13.137-1.521 15.073-19.083 9.956-24.061 11.063",
    transform: "translate(-306.486 -342.847)",
    stroke: "#7a1f2c",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-52",
    d: "M321.337 360c-4.84 2.213-8.85 4.148-9.68 5.116-2.074 2.766-4.01 6.361 14.243 6.5h.83c1.936-3.734-1.935-8.436-5.393-11.616z",
    transform: "translate(-310.328 -336.76)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 3.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-53",
    d: "M352.185 366.673c-13.69 1.106-9.956 5.67-26.274 5.67-10.648 0-14.52-1.245-15.349-2.9-.968 2.351.691 4.7 15.349 4.7 16.179 0 12.584-4.563 26.274-5.67 4.7-.415 6.361-5.531 6.223-10.371-.139 4.285-2.075 8.298-6.223 8.571z",
    transform: "translate(-310.338 -340.676)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(14.882 2.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-113",
    d: "M341.7 345v.691",
    transform: "translate(-313.214 -345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M28.625 2.074c.277 3.6.415 10.786-1.521 13.69-2.766 4.148-19.5 11.754-25.859 13.828",
    strokeDasharray: ".998 .998",
    strokeWidth: 0.25,
    stroke: "#fff",
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-113",
    d: "M321.791 366.6a1.247 1.247 0 0 1-.691.138",
    transform: "translate(-321.1 -336.731)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(17.232 27.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-54",
    d: "M324.016 365.574a1.965 1.965 0 0 1-.83-.277 1.085 1.085 0 0 1 0-1.521 1.169 1.169 0 0 1 .83-.277 1.965 1.965 0 0 1 .83.277 1.482 1.482 0 0 1 .277.83 1.965 1.965 0 0 1-.277.83c-.277 0-.554.138-.83.138z",
    transform: "translate(-322.771 -363.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-53",
    d: "M324.045 363.715c.277 0 .415.138.691.277a.775.775 0 0 1 0 1.245 1.056 1.056 0 0 1-.691.277c-.277 0-.415-.138-.691-.277a.775.775 0 0 1 0-1.245c.138-.277.415-.277.691-.277m0-.415a.986.986 0 0 0-.83.415 1.181 1.181 0 0 0 0 1.8 1.255 1.255 0 0 0 .968.415.986.986 0 0 0 .83-.415 1.2 1.2 0 0 0 .415-.83.986.986 0 0 0-.415-.83 1.2 1.2 0 0 0-.968-.553z",
    transform: "translate(-322.8 -363.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-115",
    d: "M325.078 366.114S323 359.891 320.1 359.2",
    transform: "translate(-306.601 -337.066)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(19.86 26.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-54",
    d: "M325.906 364.713a1.966 1.966 0 0 1-.83-.277 1.483 1.483 0 0 1-.277-.83 1.965 1.965 0 0 1 .277-.83 1.169 1.169 0 0 1 .83-.277 1.965 1.965 0 0 1 .83.277 1.483 1.483 0 0 1 .277.83.978.978 0 0 1-1.106 1.106z",
    transform: "translate(-324.662 -362.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-53",
    d: "M325.945 362.677c.277 0 .415.138.691.277a.775.775 0 0 1 0 1.245 1.056 1.056 0 0 1-.691.277c-.277 0-.415-.138-.691-.277a.775.775 0 0 1 0-1.245 2.336 2.336 0 0 1 .691-.277m0-.277a.986.986 0 0 0-.83.415 1.181 1.181 0 0 0 0 1.8 1.255 1.255 0 0 0 .968.415.986.986 0 0 0 .83-.415 1.2 1.2 0 0 0 .415-.83.986.986 0 0 0-.415-.83 1.044 1.044 0 0 0-.968-.553z",
    transform: "translate(-324.7 -362.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-115",
    d: "M326.9 365.214a7.934 7.934 0 0 0-4.7-6.914",
    transform: "translate(-305.797 -337.411)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(22.625 25.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-54",
    d: "M327.906 363.713a1.965 1.965 0 0 1-.83-.277 1.169 1.169 0 0 1-.277-.83 1.965 1.965 0 0 1 .277-.83 1.169 1.169 0 0 1 .83-.277 1.11 1.11 0 1 1 0 2.213z",
    transform: "translate(-326.662 -361.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-53",
    d: "M327.945 361.677c.277 0 .415.138.691.277a.775.775 0 0 1 0 1.245 1.056 1.056 0 0 1-.691.277c-.277 0-.415-.138-.691-.277a.775.775 0 0 1 0-1.245 1.056 1.056 0 0 1 .691-.277m0-.277a.986.986 0 0 0-.83.415 1.181 1.181 0 0 0 0 1.8 1.255 1.255 0 0 0 .968.415.986.986 0 0 0 .83-.415 1.181 1.181 0 0 0 0-1.8 1.494 1.494 0 0 0-.968-.415z",
    transform: "translate(-326.7 -361.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-115",
    d: "M328.825 364.214s-.553-5.393-4.425-6.914",
    transform: "translate(-304.955 -337.794)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(25.253 23.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-54",
    d: "M329.816 362.674a1.965 1.965 0 0 1-.83-.277 1.085 1.085 0 0 1 0-1.521 1.169 1.169 0 0 1 .83-.277 1.966 1.966 0 0 1 .83.277 1.483 1.483 0 0 1 .277.83 1.965 1.965 0 0 1-.277.83 1.753 1.753 0 0 1-.83.138z",
    transform: "translate(-328.571 -360.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-53",
    d: "M329.845 360.815c.277 0 .415.138.691.277a.775.775 0 0 1 0 1.245 1.056 1.056 0 0 1-.691.277c-.277 0-.415-.138-.691-.277a.775.775 0 0 1 0-1.245.894.894 0 0 1 .691-.277m0-.415a.986.986 0 0 0-.83.415 1.2 1.2 0 0 0-.415.83.986.986 0 0 0 .415.83 1.255 1.255 0 0 0 .968.415.986.986 0 0 0 .83-.415 1.181 1.181 0 0 0 0-1.8 2 2 0 0 0-.968-.277z",
    transform: "translate(-328.6 -360.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-115",
    d: "M330.725 363.276s-.415-5.116-4.425-6.776",
    transform: "translate(-304.228 -338.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(28.848 21.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-54",
    d: "M332.406 361.474c-.277 0-.415-.138-.691-.138a.76.76 0 0 1-.415-.691 1.754 1.754 0 0 1 .138-.83.986.986 0 0 1 .83-.415c.277 0 .415.138.691.138a1.105 1.105 0 0 1 .277 1.521 1.182 1.182 0 0 1-.83.415z",
    transform: "translate(-331.162 -358.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-53",
    d: "M332.445 359.515a.831.831 0 0 1 .553.138.9.9 0 0 1 .277 1.245.76.76 0 0 1-.691.415.831.831 0 0 1-.553-.138.9.9 0 0 1-.277-1.245.76.76 0 0 1 .691-.415m0-.415a.926.926 0 0 0-.968.553 2 2 0 0 0-.277.968 1.137 1.137 0 0 0 .553.83c.277.138.415.277.691.277a.926.926 0 0 0 .968-.553 1.311 1.311 0 0 0-.277-1.8 1.056 1.056 0 0 0-.691-.277z",
    transform: "translate(-331.2 -359.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-115",
    d: "M333.593 361.861s-1.521-4.563-5.393-6.361",
    transform: "translate(-303.5 -338.483)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(32.614 19.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-54",
    d: "M335.1 359.813a.508.508 0 0 1-.415-.138 1.08 1.08 0 0 1-.553-.553.881.881 0 0 1 0-.83 1.04 1.04 0 0 1 .968-.691.508.508 0 0 1 .415.138 1.08 1.08 0 0 1 .553.553.882.882 0 0 1 0 .83 1.04 1.04 0 0 1-.968.691z",
    transform: "translate(-333.884 -357.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-53",
    d: "M335.136 357.815a.508.508 0 0 1 .415.138 1.039 1.039 0 0 1 .553 1.245.86.86 0 0 1-.83.553.508.508 0 0 1-.415-.138 1.039 1.039 0 0 1-.553-1.245.934.934 0 0 1 .83-.553m0-.415a1.051 1.051 0 0 0-1.106.83 1.22 1.22 0 0 0 .691 1.659c.138 0 .277.138.553.138a1.052 1.052 0 0 0 1.106-.83 1.181 1.181 0 0 0 0-.968 1.666 1.666 0 0 0-.691-.691c-.277 0-.415-.138-.553-.138z",
    transform: "translate(-333.923 -357.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-115",
    d: "M336.484 360.046s-2.9-4.148-6.084-5.946",
    transform: "translate(-302.658 -339.019)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(36.12 17.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-54",
    d: "M337.714 358.074h-.277a1.077 1.077 0 0 1-.83-1.245 1.052 1.052 0 0 1 1.106-.83h.277a1.176 1.176 0 0 1 .691.415c.138.138.138.553.138.83a1.159 1.159 0 0 1-1.105.83z",
    transform: "translate(-336.412 -355.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-53",
    d: "M337.76 356.215h.138a.855.855 0 0 1 .691 1.106.876.876 0 0 1-.83.691h-.138a.855.855 0 0 1-.691-1.106.774.774 0 0 1 .83-.691m0-.415a1.328 1.328 0 0 0-1.245.968 1.214 1.214 0 0 0 .138.968.934.934 0 0 0 .83.553h.277a1.328 1.328 0 0 0 1.245-.968 1.215 1.215 0 0 0-.138-.968.934.934 0 0 0-.83-.553z",
    transform: "translate(-336.459 -355.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-115",
    d: "M339.391 358.331s-4.01-4.425-7.191-5.531",
    transform: "translate(-301.969 -339.516)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(39.358 14.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-54",
    d: "M340.006 355.813a1.965 1.965 0 0 1-.83-.277 1.483 1.483 0 0 1-.277-.83 1.106 1.106 0 1 1 2.213 0 1.091 1.091 0 0 1-1.106 1.106z",
    transform: "translate(-338.762 -353.462)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-53",
    d: "M340.045 353.777a.968.968 0 0 1 0 1.936.945.945 0 0 1-.968-.968 1.165 1.165 0 0 1 .968-.968m0-.277a1.245 1.245 0 1 0 1.245 1.245 1.239 1.239 0 0 0-1.245-1.245z",
    transform: "translate(-338.8 -353.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-115",
    d: "M342.188 355.663s-5.531-4.148-8.988-4.563",
    transform: "translate(-301.586 -340.167)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(40.304 9.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-54",
    d: "M340.706 352.713a1.173 1.173 0 0 1-1.106-.968 1.016 1.016 0 0 1 .277-.83.76.76 0 0 1 .691-.415 1.211 1.211 0 0 1 1.245.968 1.016 1.016 0 0 1-.277.83.836.836 0 0 1-.83.415z",
    transform: "translate(-339.44 -350.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-53",
    d: "M340.75 350.815a1.01 1.01 0 0 1 .968.83c0 .553-.277.968-.83.968h-.138a1.01 1.01 0 0 1-.968-.83.945.945 0 0 1 .968-.968m0-.415h-.138a1.238 1.238 0 0 0-1.106 1.383 1.211 1.211 0 0 0 1.245 1.106h.138a1.578 1.578 0 0 0 .83-.415 1.167 1.167 0 0 0 .277-.968 1.219 1.219 0 0 0-1.245-1.106z",
    transform: "translate(-339.485 -350.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-115",
    d: "M343.08 352.067s-6.084-2.9-9.68-2.766",
    transform: "translate(-301.51 -340.858)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(40.407 5.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-54",
    d: "M340.8 349.451a1.04 1.04 0 0 1-.968-.691.882.882 0 0 1 0-.83 1.381 1.381 0 0 1 .553-.691c.138 0 .277-.138.415-.138a1.04 1.04 0 0 1 .968.691 1.163 1.163 0 0 1-.553 1.521c-.003.138-.28.138-.415.138z",
    transform: "translate(-339.496 -347.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-53",
    d: "M340.86 347.377a.86.86 0 0 1 .83.553.95.95 0 0 1-.415 1.245c-.138 0-.277.138-.415.138a.86.86 0 0 1-.83-.553.95.95 0 0 1 .415-1.245c.138 0 .277-.138.415-.138m0-.277a.831.831 0 0 0-.553.138 1.109 1.109 0 0 0-.553 1.659 1.41 1.41 0 0 0 1.106.691.831.831 0 0 0 .553-.138 1.109 1.109 0 0 0 .553-1.659 1.1 1.1 0 0 0-1.106-.691z",
    transform: "translate(-339.559 -347.1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-115",
    d: "M343.065 348.358s-5.946-2.074-9.265-.968",
    transform: "translate(-301.356 -341.712)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(253.748 248.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-76",
    transform: "translate(49.09 82.001)",
    d: "M0 0h15.073v23.231H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-116",
    transform: "translate(49.09 82.001)",
    d: "M0 0h15.073v4.84H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-76",
    d: "M290.254 260.337H190.138a6.639 6.639 0 0 1-6.638-6.637v-70.662a6.639 6.639 0 0 1 6.638-6.638h100.116a6.639 6.639 0 0 1 6.638 6.638V253.7a6.639 6.639 0 0 1-6.638 6.637z",
    transform: "translate(-183.5 -176.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M292.013 176.6a6.94 6.94 0 0 1 .277 1.659v70.662a6.639 6.639 0 0 1-6.638 6.638H185.536a9.338 9.338 0 0 1-1.936-.277 6.522 6.522 0 0 0 6.361 4.978h100.116a6.639 6.639 0 0 0 6.638-6.638v-70.661a6.4 6.4 0 0 0-4.702-6.361z",
    transform: "translate(-183.462 -176.323)",
    fill: "#212f38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    className: "cls-118",
    cx: 39.549,
    cy: 4.978,
    rx: 39.549,
    ry: 4.978,
    transform: "translate(17.147 99.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-116",
    d: "M257.018 255.756h-50.473a1.239 1.239 0 0 1-1.245-1.245 8.676 8.676 0 0 1 8.712-8.712h35.538a8.676 8.676 0 0 1 8.712 8.712 1.239 1.239 0 0 1-1.244 1.245z",
    transform: "translate(-175.154 -149.832)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(28.348 34.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-119",
    d: "M257.792 237.592h-51.026a2.774 2.774 0 0 1-2.766-2.766v-30.56a2.774 2.774 0 0 1 2.766-2.766h51.026a2.774 2.774 0 0 1 2.766 2.766v30.56a2.774 2.774 0 0 1-2.766 2.766z",
    transform: "translate(-204 -201.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(39.549 23.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-120",
    d: "M233.291 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-232.6 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-120",
    d: "M234.891 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-231.987 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-120",
    d: "M236.491 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-231.375 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-120",
    d: "M238.191 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.741.741 0 0 1-.691.691z",
    transform: "translate(-230.724 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-120",
    d: "M239.791 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-230.112 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-120",
    d: "M241.391 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-229.499 -218.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-120",
    d: "M242.991 229.148a.653.653 0 0 1-.691-.691v-9.265a.653.653 0 0 1 .691-.691.653.653 0 0 1 .691.691v9.265a.653.653 0 0 1-.691.691z",
    transform: "translate(-228.887 -218.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(223.741 329.134)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-118",
    cx: 14.243,
    cy: 3.042,
    rx: 14.243,
    ry: 3.042,
    transform: "translate(.83 19.774)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-90",
    d: "M172.192 258.485h7.052a7.378 7.378 0 0 0 7.329-7.329v-14.935a1.535 1.535 0 0 0-1.521-1.521h-18.53a1.535 1.535 0 0 0-1.522 1.521v14.935a7.172 7.172 0 0 0 7.192 7.329z",
    transform: "translate(-160.576 -234.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M184.592 234.7h-.277v14.934a7.378 7.378 0 0 1-7.329 7.329h-7.052a6.955 6.955 0 0 1-3.734-1.106 7.421 7.421 0 0 0 5.531 2.489h7.052a7.377 7.377 0 0 0 7.329-7.329v-14.934a1.515 1.515 0 0 0-1.52-1.383z",
    transform: "translate(-160.116 -234.7)",
    fill: "#541400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M0 10.786a7.467 7.467 0 1 0 7.467-7.467A7.35 7.35 0 0 0 0 10.786z",
    strokeWidth: 1.5,
    stroke: "#631700",
    fill: "none",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(370.735 328.166)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-118",
    cx: 14.243,
    cy: 3.042,
    rx: 14.243,
    ry: 3.042,
    transform: "translate(.83 19.774)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-119",
    d: "M278.492 257.785h7.052a7.377 7.377 0 0 0 7.329-7.329v-14.935a1.535 1.535 0 0 0-1.521-1.521h-18.53a1.535 1.535 0 0 0-1.521 1.521v14.934a7.172 7.172 0 0 0 7.191 7.33z",
    transform: "translate(-266.876 -234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M290.892 234h-.277v14.934a7.377 7.377 0 0 1-7.329 7.329h-7.052a6.955 6.955 0 0 1-3.734-1.106 7.421 7.421 0 0 0 5.531 2.489h7.052a7.377 7.377 0 0 0 7.329-7.329v-14.934a1.515 1.515 0 0 0-1.52-1.383z",
    transform: "translate(-266.416 -234)",
    fill: "#141f24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M0 10.648a7.467 7.467 0 1 0 7.467-7.467A7.436 7.436 0 0 0 0 10.648z",
    stroke: "#19252b",
    strokeWidth: 1.5,
    fill: "none",
    strokeMiterlimit: 10
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitInformationImage);
export default __webpack_public_path__ + "static/media/submit_information_image.1d21b1ae4a35d10c707d9cde8bedb046.svg";
export { ForwardRef as ReactComponent };